<div
  class="add-sale-page-wrapper mt-3 position-relative"
  
  id="spt-order-wrapper"
>
  <dx-load-panel
    [hideOnOutsideClick]="false"
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="loadingIndicator"
  >
  </dx-load-panel>
  <div id="mySidenav1" class="sidenav">
    <app-order-amount-job
      [qtyRight]="qtyRight"
      [qtyLeft]="qtyLeft"
      [lensePriceRight]="$lensePriceRight"
      [lensePriceLeft]="$lensePriceLeft"
      [leftOval]="$leftOval"
      [rightOval]="$rightOval"
      [leftPrismPrice]="$leftPrismPrice"
      [rightPrismPrice]="$rightPrismPrice"
      [rightFittingPrice]="$rightFittingPrice"
      [leftCtPrice]="$leftCtPrice"
      [rightCtPrice]="$rightCtPrice"
      [leftEtPrice]="$leftEtPrice"
      [rightEtPrice]="$rightEtPrice"
      [leftBaseCurvePrice]="$leftBaseCurvePrice"
      [rightBaseCurvePrice]="$rightBaseCurvePrice"
      [leftDecPrice]="$leftDecPrice"
      [rightDecPrice]="$rightDecPrice"
      [fittingPrice]="$fittingPrice"
      [tailorMadePrice]="$tailorMadePrice"
      [selectedOtherServicePrice]="$selectedOtherServicePrice"
      [engraveName]="$engraveName"
      [specialLogo]="$specialLogo"
      [hcPrice]="$hcPrice"

      [rightCoatingPrice]="$coatingPriceRight"
      [leftCoatingPrice]="$coatingPriceLeft"

      [rightMirrorPrice]="$mirrorPriceRight"
      [leftMirrorPrice]="$mirrorPriceLeft"
      
      [leftTintPrice]="$tintPriceLeft"
      [rightTintPrice]="$tintPriceRight"

      [additionalPrice]="$additionalPrice"
      [discountPrice]="$discountPrice"
      [selectedTemplate]="selectedTemplate"
      [editFittingPrice]="true"
      (valueChange)="priceValueChange($event)"
    >
    </app-order-amount-job>
  </div>
  <div class="orderPrice" *ngIf="
  bothSidesForm.get('customerBranchId').value &&
  bothSidesForm.get('customerTypeId').value
" (click)="openNav()">
    <a href="javascript:void(0)"  [ngClass]="checkHasPrice ? 'text-green' : 'text-white'"><i class="fa" 
      [ngClass]="checkHasPrice ? 'fa-cart-arrow-down' : 'fa-shopping-cart'"></i></a>
  </div>
  

 
  <div class="container-fluid" #customerInformation>
    <form [formGroup]="bothSidesForm" #f="ngForm">
      <div id="main1">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-md-8 d-flex align-items-center">
                <!-- <dx-button
                    *ngIf="
                      bothSidesForm.get('customerBranchId').value &&
                      bothSidesForm.get('customerTypeId').value
                    "
                    icon="fa fa-align-justify"
                    text="Order Price"
                    class="m-0"
                    (click)="openNav()"
                  >
                  </dx-button> -->
              </div>
              <div class="col-md-2 d-flex align-items-center justify-content-center">
                <mat-checkbox
                  color="primary"
                  formControlName="asRedo"
                  *ngIf="!salesOrderId && salesOrderData?.complainStatus"
                  (change)="getRedo(bothSidesForm.get('asRedo').value)"
                  ><u>ReDo </u></mat-checkbox>
              </div>

               <div class="col-md-12 d-flex justify-content-end">
  <div class="dx-field hightLight" *ngIf="!salesOrderId">

    <!-- Toggle link -->
    <a
      href="javascript:void(0)"
      (click)="toggleSalesInput()"
      class="text-primary fw-bold"
      style="cursor: pointer;"
    >
      {{ showSalesInput ? 'Hide Copy Order From' : 'Copy Order From' }}
    </a>

    <!-- Collapsible section -->
    <div *ngIf="showSalesInput" class="mt-2">
      <label class="form-label d-block mb-1">Copy Order From:</label>
    <dx-number-box
  [inputAttr]="{ autocomplete: 'off', inputmode: 'numeric', id: 'salesOrderInput' }"
  formControlName="salesId"
  type="text"
  placeholder="Enter order number..."
  (onKeyDown)="blockIllegalKeys($event)"
  (onValueChanged)="cleanSalesId($event)">
  <dxi-button
    name="today"
    location="after"
    [options]="salesOrderButton">
  </dxi-button>
</dx-number-box>



    </div>

  </div>
</div>


            </div>
            
            <!-- CUSTOMER INFORMATION -->
            <app-panel [footer]="false">
              <div class="heading">Customer Information</div>
              <div class="toolbar" *ngIf="salesOrderId">
                Order #. {{ salesOrderId }}
              </div>
              <div class="body">
                <div class="row">
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="customerTypeId"
                          text="Customer Type *"
                        ></kendo-label>
                        <!-- (valueChange)="
                            filterCustomer(
                              bothSidesForm.get('customerTypeId').value
                            )
                          " -->
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="true"
                          #customerTypeId
                          [tabIndex]="1"
                          [readonly]="true"
                          class="w-100"
                          [loading]="loadingCustomerType"
                          formControlName="customerTypeId"
                          [valuePrimitive]="true"
                          [data]="customerTypelist"
                          [valueField]="'customerTypeId'"
                          [textField]="'customerTypeName'"
                          [filterable]="true"
                          [loading]="loadingCustomerType"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          required
                          
                          [placeholder]="
                            loadingCustomerType
                              ? 'Please wait...'
                              : 'Choose Customer Type'
                          "
                        >
                        </kendo-combobox>
                        <kendo-formerror
                          >Customer Type is required</kendo-formerror
                        >
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="customerBranchId"
                          text="Customer Name *"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="true"
                          #customerBranchId
                          [readonly]="!isAdmin && !isSupervisor && (
                            !bothSidesForm.get('customerTypeId').value || 
                            (salesOrderData?.holdProcess && salesOrderData?.processId > 15))"
                          class="w-100"
                          [loading]="loadingCustomerType"
                          formControlName="customerBranchId"
                          [valuePrimitive]="true"
                          [data]="customerList"
                          [valueField]="'customerBranchId'"
                          [textField]="'customerName'"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          required
                          [tabIndex]="2"
                          (valueChange)="changeCustomerEvent($event)"
                          [placeholder]="'Choose Customer Name'"
                        >
                        <!-- getCustomerChange() -->
                        </kendo-combobox>
                        <kendo-formerror
                          *ngIf="
                            bothSidesForm.get('customerBranchId').errors
                              ?.required
                          "
                          >Customer Name is required</kendo-formerror
                        >
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="customerContactId"
                          text="Customer Contact"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="true"
                          #customerContactId
                          [loading]="loadingCustomerType"
                          [readonly]="
                            bothSidesForm.get('customerBranchId').value
                              ? null
                              : true
                          "
                          class="w-100"
                          formControlName="customerContactId"
                          [valuePrimitive]="true"
                          [data]="customerContactList"
                          [valueField]="'customerContactId'"
                          [textField]="'contactName'"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          [tabIndex]="3"
                          [loading]="loadingCustomerContact"
                          [placeholder]="
                            loadingCustomerContact
                              ? 'Please wait...'
                              : 'Choose Customer Contact'
                          "
                        >
                        </kendo-combobox>
                      </kendo-formfield>
                    </div>
                  </div>
                  <!-- <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="companyBranchId"
                          text="Order to Plant *"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="true"
                          #companyBranchId
                          [tabIndex]="4"
                          [readonly]="allCompanyBranches?.length == 0"
                          class="w-100"
                          [loading]="loadingCustomerType"
                          formControlName="companyBranchId"
                          [valuePrimitive]="true"
                          [readonly]="rxProcessRole"
                          [data]="allCompanyBranches"
                          [valueField]="'companyBranchId'"
                          [textField]="'companyBranchName'"
                          [filterable]="true"
                          [loading]="loadingCustomerType"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          required
                          (valueChange)="
                            setBranchValue(
                              bothSidesForm.get('companyBranchId').value
                            )
                          "
                          [placeholder]="
                            loadingCustomerType
                              ? 'Please wait...'
                              : 'Choose Order to Plant'
                          "
                        >
                        </kendo-combobox>
                        <kendo-formerror>Branch is required</kendo-formerror>
                      </kendo-formfield>
                    </div>
                  </div> -->
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="urgencyTypeId"
                          text="Urgency Type *"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="true"
                          #urgencyTypeId
                          [tabIndex]="5"
                          class="w-100"
                          formControlName="urgencyTypeId"
                          [valuePrimitive]="true"
                          [data]="urgencyTypeList"
                          [valueField]="'urgencyTypeId'"
                          [textField]="'urgencyTypeName'"
                          required
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          placeholder="Choose Urgency Type"
                        >
                        </kendo-combobox>
                        <kendo-formerror
                          >Urgency Type is required</kendo-formerror
                        >
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="patientName"
                          text="Patient Name"
                        ></kendo-label>
                        <kendo-textbox
                          class="w-100"
                          [tabIndex]="6"
                          #patientName
                          formControlName="patientName"
                          placeholder="Patient Name"
                        >
                        </kendo-textbox>
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="ponumberTextbox"
                          text="{{
                            selectedCustomerContactEvent?.providePO
                              ? 'PO Ref.# *'
                              : 'PO Ref.#'
                          }}"
                        ></kendo-label>
                        <kendo-textbox
                          class="w-100"
                          [tabIndex]="7"
                          #ponumberTextbox
                          formControlName="ponumber"
                          placeholder="{{
                            selectedCustomerContactEvent?.providePO
                              ? 'PO Ref.# *'
                              : 'PO Ref.#'
                          }}"
                          [readonly]="
                            !bothSidesForm.get('customerBranchId').value
                          "
                          (inputBlur)="
                            isValidatePONumber(
                              bothSidesForm.get('ponumber').value,
                              customerId
                            )
                          "
                        >
                        </kendo-textbox>
                        <kendo-formerror
                          *ngIf="selectedCustomerContactEvent?.providePO"
                          >PO Ref.# is required"</kendo-formerror
                        >
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="partnerOrderNumber"
                          text="Partner Order.#"
                        ></kendo-label>
                        <kendo-textbox
                          class="w-100"
                          [tabIndex]="8"
                          #partnerOrderNumber
                          formControlName="partnerOrderNumber"
                          placeholder="Partner Order.#"
                        >
                        </kendo-textbox>
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label text="Instruction"></kendo-label>
                        <kendo-textbox
                          [tabIndex]="9"
                          class="w-100"
                          formControlName="instruction"
                          placeholder="Instruction"
                        >
                        </kendo-textbox>
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label text="Remarks"></kendo-label>
                        <kendo-textbox
                          class="w-100"
                          [tabIndex]="10"
                          formControlName="remarks"
                          placeholder="Remarks"
                        >
                        </kendo-textbox>
                      </kendo-formfield>
                    </div>
                  </div>
                  <!-- <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <mat-checkbox
                        (change)="isOurLenseRole($event);getEdgingPrice(
                          selectedItemCatalogObject?.brandMasterId,
                          customerId,
                          selectedItemCatalogObject?.indexId,
                          selectedItemCatalogObject?.materialId,
                          bothSidesForm.get('frameType').value,
                          bothSidesForm.get('isOurLens').value
                        )"
                        class="enter-keypress-focus-input mb-0"
                        formControlName="isOurLens"
                        color="primary"
                        [tabIndex]="11"
                      >
                        Party Lens
                      </mat-checkbox>
                    </div>
                  </div> -->
                  <div
                    class="col-md-2"
                    *ngIf="bothSidesForm.get('isOurLens').value"
                  >
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="true"
                          #cutUncutLensId
                          class="w-100"
                          [loading]="loadingCuts"
                          formControlName="cutUncutLensId"
                          [valuePrimitive]="true"
                          [data]="cutUnCutsList"
                          [valueField]="'cutUncutId'"
                          [textField]="'cutUncutName'"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          [tabIndex]="12"
                          (valueChange)="
                            getCutUncutLensId(
                              bothSidesForm.get('cutUncutLensId').value
                            )
                          "
                          [placeholder]="'Choose...'"
                        >
                        </kendo-combobox>
                        <kendo-formerror
                          *ngIf="bothSidesForm.get('cutUncutLensId').errors?.required"
                          >CutUncut is required"</kendo-formerror
                        >
                      </kendo-formfield>
                    </div>
                  </div>
                </div>
              </div>
            </app-panel>
            <!--/ CUSTOMER INFORMATION -->

            <div class="row mt-3 mb-3">
              <div class="col-sm-12">
                <div class="text-center">
                  <mat-radio-group
                    [(ngModel)]="selectedTemplate"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="changeTemplate()"
                    [tabIndex]="13"
                  >
                    <mat-radio-button
                      class="animated slideInRight mr-2"
                      color="primary"
                      value="both"
                      >Both</mat-radio-button
                    >
                    <mat-radio-button
                      class="animated slideInRight mr-2"
                      color="primary"
                      value="right"
                      >Right</mat-radio-button
                    >
                    <mat-radio-button
                      class="animated slideInRight"
                      color="primary"
                      value="left"
                      >Left</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>
            <!-- ITEM CATALOG WITH FILTER -->
            <div class="row mt-3">
              <div class="col-md-12">
                <app-panel [backArrow]="false" [footer]="false">
                  <div class="heading">Filters</div>
                  <div class="body">
                    <div class="row">
                      <!-- NEW FILTERS -->
                      <ng-container formGroupName="itemCatalogFilters">
                        <div class="col">
                          <div class="dx-field hightLight" id="brandMasterId">
                            <kendo-formfield>
                              <kendo-label
                                [for]="brandMasterId"
                                text="Brands *"
                              ></kendo-label>
                              <kendo-combobox
                                [virtual]="true"
                                [clearButton]="true"
                                #brandMasterId
                                [readonly]="!customerId"
                                class="w-100"
                                formControlName="brandMasterId"
                                [valuePrimitive]="true"
                                [data]="brandMasterList"
                                [valueField]="'brandMasterId'"
                                [textField]="'brandName'"
                                [filterable]="true"
                                [kendoDropDownFilter]="{ operator: 'contains' }"
                                [suggest]="true"
                                (valueChange)="getViewItemCatalog()"
                                [placeholder]="'Choose Brands'"
                                [tabIndex]="14"
                              >
                              </kendo-combobox>
                              <kendo-formerror
                                >Brands is required</kendo-formerror
                              >
                            </kendo-formfield>
                          </div>
                        </div>
                        <div class="col-auto">
                          <div class="dx-field hightLight">
                            <kendo-formfield>
                              <kendo-label
                                [for]="materialName"
                                text="Material"
                              ></kendo-label>
                              <kendo-combobox
                                [virtual]="true"
                                [clearButton]="true"
                                #materialName
                                [readonly]="!allMaterials?.length"
                                class="w-100"
                                formControlName="materialId"
                                [valuePrimitive]="true"
                                [data]="allMaterials"
                                [valueField]="'materialId'"
                                [textField]="'materialName'"
                                [filterable]="true"
                                [kendoDropDownFilter]="{ operator: 'contains' }"
                                [suggest]="true"
                                (valueChange)="
                                  getAllIndexByMaterialId(
                                    bothSidesForm
                                      .get('itemCatalogFilters')
                                      .get('materialId').value
                                  )
                                "
                                [placeholder]="
                                  loadingMaterials
                                    ? 'Please wait...'
                                    : 'Choose Material'
                                "
                                [tabIndex]="15"
                              >
                              </kendo-combobox>
                            </kendo-formfield>
                          </div>
                        </div>
                        <div class="col-auto">
                          <div class="dx-field hightLight">
                            <kendo-formfield>
                              <kendo-label
                                [for]="focalName"
                                text="Focal"
                              ></kendo-label>
                              <kendo-combobox
                                [virtual]="true"
                                [clearButton]="true"
                                #focalName
                                [readonly]="!focalIdsList?.length"
                                class="w-100"
                                formControlName="focalId"
                                [valuePrimitive]="true"
                                [data]="focalIdsList"
                                [valueField]="'focalId'"
                                [textField]="'focalName'"
                                [filterable]="true"
                                [kendoDropDownFilter]="{ operator: 'contains' }"
                                [suggest]="true"
                                (valueChange)="getViewItemCatalog()"
                                [placeholder]="
                                  loadingFocal
                                    ? 'Please wait...'
                                    : 'Choose Focal'
                                "
                                [tabIndex]="16"
                              >
                              </kendo-combobox>
                            </kendo-formfield>
                          </div>
                        </div>
                        <div class="col-auto">
                          <div class="dx-field hightLight">
                            <kendo-formfield>
                              <kendo-label
                                [for]="indexValue"
                                text="Indexs"
                              ></kendo-label>
                              <kendo-combobox
                                [virtual]="true"
                                [clearButton]="true"
                                #indexValue
                                [readonly]="!leftIndexList?.length"
                                class="w-100"
                                formControlName="indexId"
                                [valuePrimitive]="true"
                                [data]="leftIndexList"
                                [valueField]="'indexId'"
                                [textField]="'indexName'"
                                [filterable]="true"
                                [kendoDropDownFilter]="{ operator: 'contains' }"
                                [suggest]="true"
                                (valueChange)="getViewItemCatalog()"
                                [placeholder]="
                                  loadingLeftIndex
                                    ? 'Please wait...'
                                    : 'Choose Indexs'
                                "
                                [tabIndex]="17"
                              >
                              </kendo-combobox>
                            </kendo-formfield>
                          </div>
                        </div>
                        <div class="col-auto">
                          <div class="dx-field hightLight">
                            <kendo-formfield>
                              <kendo-label
                                [for]="filterName"
                                text="Filters"
                              ></kendo-label>
                              <kendo-combobox
                                [virtual]="true"
                                [clearButton]="true"
                                #filterName
                                [readonly]="!allFilters?.length"
                                class="w-100"
                                formControlName="filterId"
                                [valuePrimitive]="true"
                                [data]="allFilters"
                                [valueField]="'filterId'"
                                [textField]="'filterName'"
                                [filterable]="true"
                                [kendoDropDownFilter]="{ operator: 'contains' }"
                                [suggest]="true"
                                (valueChange)="getViewItemCatalog()"
                                [placeholder]="
                                  loadingFilters
                                    ? 'Please wait...'
                                    : 'Choose Filters'
                                "
                                [tabIndex]="18"
                              >
                              </kendo-combobox>
                            </kendo-formfield>
                          </div>
                        </div>
                      </ng-container>
                      <!-- / NEW FILTERS -->
                      <div class="col-md-4">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="itemCatalog"
                              text="Lens Type *"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              [clearButton]="true"
                              #itemCatalog
                              [readonly]="
                                itemCatalogList?.length == 0 || rxProcessRole
                              "
                              class="w-100"
                              [loading]="loadingItemCatalog"
                              formControlName="itemCatalogGroupId"
                              [valuePrimitive]="true"
                              [data]="itemCatalogList"
                              [valueField]="'itemCatalogGroupId'"
                              [textField]="'itemName'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [suggest]="true"
                              (valueChange)="
                                filtersByItemCatalog(
                                  bothSidesForm.get('itemCatalogGroupId').value
                                )
                              "
                              [placeholder]="'Choose Lens Type'"
                              [tabIndex]="19"
                            >
                            </kendo-combobox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('itemCatalogGroupId').errors
                                  ?.required
                              "
                              >Lens Type is required</kendo-formerror
                            >
                            <!-- <kendo-formerror
                                *ngIf="
                                  bothSidesForm.get('itemCatalogGroupId').errors
                                    ?.LensePrice
                                "
                                >Lense price not found in this
                                item</kendo-formerror
                              > -->
                          </kendo-formfield>
                          <div
                            class="lensePrice"
                            *ngIf="bothSidesForm.get('itemCatalogGroupId').value && lensRightPriceRole"
                          >
                            Right Lense price not found in this item
                          </div>
                          <div
                            class="lensePrice"
                            *ngIf="bothSidesForm.get('itemCatalogGroupId').value &&  lensLeftPriceRole"
                          >
                            Left Lense price not found in this item
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1" *ngIf="segmentHeightRoles">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="segmentHeight"
                              text="Seg. Height"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #segmentHeight
                              [step]="0.1"
                              id="segmentHeight"
                              [min]="5"
                              [readonly]="rxProcessRole"
                              [max]="40"
                              [format]="'n1'"
                              [tabIndex]="20"
                              class="w-100"
                              formControlName="segmentHeight"
                              [rangeValidation]="false"
                              placeholder="Seg. Height"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('segmentHeight').errors
                                  ?.required
                              "
                              >value is required</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('segmentHeight').errors?.range
                              "
                              >Min: 5 & Max: 40 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('segmentHeight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label [for]="ffv" text="FFV"></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #ffv
                              [step]="0.1"
                              id="ffv"
                              [min]="-1"
                              [readonly]="rxProcessRole"
                              [max]="6"
                              [format]="'n1'"
                              [tabIndex]="21"
                              class="w-100"
                              formControlName="ffv"
                              [rangeValidation]="false"
                              placeholder="FFV"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('ffv').errors?.range"
                              >Min: -1 & Max: 6 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('ffv').errors?.stepError"
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label [for]="bvd" text="BVD"></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #bvd
                              [step]="0.1"
                              id="bvd"
                              [min]="5"
                              [readonly]="rxProcessRole"
                              [max]="30"
                              [format]="'n1'"
                              [tabIndex]="22"
                              class="w-100"
                              formControlName="bvd"
                              [rangeValidation]="false"
                              placeholder="BVD"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('bvd').errors?.range"
                              >Min: 5 & Max: 30 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('bvd').errors?.stepError"
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label [for]="pa" text="PA"></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #pa
                              [step]="0.1"
                              id="pa"
                              [min]="-20"
                              [readonly]="rxProcessRole"
                              [max]="30"
                              [format]="'n1'"
                              [tabIndex]="23"
                              class="w-100"
                              formControlName="pa"
                              [rangeValidation]="false"
                              placeholder="PA"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('pa').errors?.range"
                              >Min: -20 & Max: 30 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('pa').errors?.stepError"
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label [for]="wrap" text="Wrap"></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #wrap
                              [step]="0.1"
                              id="wrap"
                              [min]="-5"
                              [readonly]="rxProcessRole"
                              [max]="30"
                              [format]="'n1'"
                              [tabIndex]="24"
                              class="w-100"
                              formControlName="wrap"
                              [rangeValidation]="false"
                              placeholder="Wrap"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('wrap').errors?.range"
                              >Min: -5 & Max: 30 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('wrap').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label [for]="nwd" text="NWD"></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #nwd
                              [step]="0.01"
                              id="nwd"
                              [min]="0.2"
                              [readonly]="rxProcessRole"
                              [max]="0.99"
                              [format]="'n2'"
                              [tabIndex]="25"
                              class="w-100"
                              formControlName="nwd"
                              [rangeValidation]="false"
                              placeholder="NWD"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('nwd').errors?.range"
                              >Min: 0.20 & Max: 0.99 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('nwd').errors?.stepError"
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label [for]="mid" text="MID"></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #mid
                              [step]="1"
                              id="mid"
                              [min]="1"
                              [readonly]="rxProcessRole"
                              [max]="4"
                              [format]="'n0'"
                              [tabIndex]="26"
                              class="w-100"
                              formControlName="mid"
                              [rangeValidation]="false"
                              placeholder="MID"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('mid').errors?.range"
                              >Min: 1 & Max: 4 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('mid').errors?.stepError"
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label [for]="age" text="AGE"></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #age
                              [step]="1"
                              id="age"
                              [min]="20"
                              [readonly]="rxProcessRole"
                              [max]="100"
                              [format]="'n0'"
                              [tabIndex]="27"
                              class="w-100"
                              formControlName="age"
                              [rangeValidation]="false"
                              placeholder="AGE"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('age').errors?.range"
                              >Min: 20 & Max: 100 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('age').errors?.stepError"
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label text="Special Base"></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              [step]="0.01"
                              [min]="0"
                              [format]="'n2'"
                              formControlName="specialBase"
                              placeholder="Enter Special Base"
                              (keydown)="restrictDecimalPlaces($event)"
                            >
                            </kendo-numerictextbox>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-1 mt-3">
                        
                        <mat-checkbox
                          formControlName="fitting"
                          [disabled]="getFittingProcessRole"
                          [tabIndex]="28"
                          color="primary"
                          (change)="toggleFitting($event)"
                          ><u>Fitting</u></mat-checkbox>
                      </div>
                      <div class="col-md-1 p-0 mt-3">
                          <mat-checkbox
                          formControlName="tailorMade"
                          color="primary"
                          [tabIndex]="29"
                          [disabled]="getFittingProcessRole"
                          (change)="toggleTailorMade($event)"
                          ><u>Tailor Made </u></mat-checkbox>
                          <div class="lensePrice" *ngIf="tailorMadePriceRole">
                            Price is required
                          </div>
                      </div>
                      <div
                        class="col-md-1 p-0 mt-3"
                      >
                        <mat-checkbox
                          [disabled]="rxProcessRole"
                          formControlName="isWaitforSample"
                          class="enter-keypress-focus-input"
                          color="primary"
                          [tabIndex]="30"
                          ><u>Wait for Sample</u></mat-checkbox
                        >
                      </div>
                      <!-- <div class="col-md-2 p-0 d-flex align-items-center" *ngIf="comboPriceList?.length > 0">
                        <button
                          id="comboprice"
                          class="btn btn-sm btn-success mr-1"
                          type="button"
                          (click)="showComboPricePopup()">
                            Combo Price
                        </button>
                        <button
                          id="comboprice"
                          class="btn btn-sm btn-secondary"
                          type="button"
                          (click)="clearCombo('clearItemGroup')">
                            Clear Combo
                        </button>
                      </div> -->
                    </div>
                  </div>
                </app-panel>
              </div>
            </div>
            <!-- / ITEM CATALOG WITH FILTER -->
            <!-- RX INFORMATION -->
            <div class="row mt-3">
              <!-- RIGHT RX INFORMATION -->
              <div class="col-md-6">
                <app-panel [backArrow]="false">
                  <div class="heading">Right RX Information</div>
                  <div class="body">
                    <div class="row">
                      <div class="col-md-2 position-relative" id="sphRight">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="sphRight"
                              text="SPH"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              (focus)="tempValidate('sphRight')"
                              [clearButton]="false"
                              #sphRight
                              class="w-100"
                              [loading]="loadingSphRange"
                              formControlName="sphRight"
                              [valuePrimitive]="true"
                              [data]="sphRangeList"
                              [readonly]="rxProcessRole"
                              [valueField]="'sphValue'"
                              [textField]="'sphValue'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [suggest]="true"
                              [placeholder]="'SPH'"
                              (valueChange)="
                                getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphRight').value,
                                  bothSidesForm.get('cylRight').value,
                                  bothSidesForm.get('addfRight').value,
                                  'right',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterRight').value, bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                );getRightCYL(selectedItemCatalogObject.cylMinExt, selectedItemCatalogObject.cylMaxExt)

                              "
                              [tabIndex]="31"
                            >
                            </kendo-combobox>
                          </kendo-formfield>
                          <dx-tooltip
                            target="#sphRight"
                            [visible]="sphRightTooltip"
                            [hideOnOutsideClick]="false"
                          >
                            <div
                              *dxTemplate="let data = data; of: 'content'"
                              style="font-size: 14px; color: rgb(217, 83, 79)"
                            >
                              SPH value is required
                            </div>
                          </dx-tooltip>
                        </div>
                      </div>
                      <div class="col-md-2 position-relative" id="cylRight">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="cylRight"
                              text="CYL"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              (focus)="tempValidate('cylRight')"
                              [clearButton]="false"
                              #cylRight
                              class="w-100"
                              [loading]="loadingCylRange"
                              formControlName="cylRight"
                              [valuePrimitive]="true"
                              [data]="rightCylRangeList"
                              [readonly]="rxProcessRole"
                              [valueField]="'cylValue'"
                              [textField]="'cylValue'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [suggest]="true"
                              [placeholder]="'CYL'"
                              [tabIndex]="32"
                              (valueChange)="
                                getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphRight').value,
                                  bothSidesForm.get('cylRight').value,
                                  bothSidesForm.get('addfRight').value,
                                  'right',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterRight').value,
                                  bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                )
                              "
                            >
                            </kendo-combobox>
                          </kendo-formfield>
                          <dx-tooltip
                            target="#cylRight"
                            [visible]="cylRightTooltip"
                            [hideOnOutsideClick]="false"
                          >
                            <div
                              *dxTemplate="let data = data; of: 'content'"
                              style="font-size: 14px; color: rgb(217, 83, 79)"
                            >
                              CYL value is required
                            </div>
                          </dx-tooltip>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="axisRight"
                              text="{{ validateAxisRight ? 'AXIS *' : 'AXIS' }}"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #axisRight
                              [step]="1"
                              NumberValidate
                              [min]="1"
                              [max]="180"
                              [format]="'n0'"
                              [tabIndex]="33"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              SignNotAllowed="43"
                              [rangeValidation]="false"
                              (valueChange)="validateZeroValue('axisRight')"
                              formControlName="axisRight"
                              placeholder="{{
                                validateAxisRight ? 'AXIS *' : 'AXIS'
                              }}"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('axisRight').errors?.required
                              "
                              >value is required</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('axisRight').errors?.range
                              "
                              >Min: 1 & Max: 180 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('axisRight').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2 position-relative" id="addfRight">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="addfRight"
                              text="ADD"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              (focus)="tempValidate('addfRight')"
                              [clearButton]="false"
                              #addfRight
                              class="w-100"
                              [loading]="loadingAddfRange"
                              formControlName="addfRight"
                              [valuePrimitive]="true"
                              [data]="addfRangeList"
                              [valueField]="'addfValue'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [textField]="'addfValue'"
                              [suggest]="true"
                              [placeholder]="'ADD'"
                              [readonly]="rxProcessRole"
                              [tabIndex]="34"
                              (valueChange)="
                                getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphRight').value,
                                  bothSidesForm.get('cylRight').value,
                                  bothSidesForm.get('addfRight').value,
                                  'right',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterRight').value,
                                  bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                )
                              "
                            >
                            </kendo-combobox>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="qtyRightLabel"
                              text="QTY *"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              NumberValidate
                              #qtyRightLabel
                              [min]="1"
                              [step]="1"
                              [format]="'n0'"
                              [tabIndex]="35"
                              (valueChange)="
                                validateZeroValue('qtyRight'); getLeftQtyRole(); warringMsg(bothSidesForm.get('qtyRight').value)
                              "
                              class="w-100"
                              formControlName="qtyRight"
                              (blur)="
                                getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphRight').value,
                                  bothSidesForm.get('cylRight').value,
                                  bothSidesForm.get('addfRight').value,
                                  'right',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterRight').value,
                                  bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                );updateLensePriceForCombo(selectedTemplate)
                              "
                              placeholder="QTY *"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror>value is required</kendo-formerror>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="diameterRight"
                              text="DIAMETER *"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #diameterRight
                              [step]="1"
                              [min]="48"
                              [format]="'n0'"
                              [tabIndex]="36"
                              [max]="80"
                              [rangeValidation]="false"
                              [readonly]="rxProcessRole"
                              (valueChange)="validateZeroValue('diameterRight')"
                              class="w-100"
                              formControlName="diameterRight"
                              (blur)="
                                disableOvalRightCheckBox(
                                  bothSidesForm.get('diameterRight').value
                                );getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphRight').value,
                                  bothSidesForm.get('cylRight').value,
                                  bothSidesForm.get('addfRight').value,
                                  'right',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterRight').value,
                                  bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                )
                              "
                              placeholder="DIAMETER *"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror>value is required</kendo-formerror>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('diameterRight').errors?.range
                              "
                              >Min: 48 & Max: 80 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('diameterRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      
                      <div
                        class="col-md-2 d-flex align-items-center justify-content-center"
                      >
                        <mat-checkbox
                          color="primary"
                          (change)="
                            isOvalRightChange(
                              this.bothSidesForm.get('isOvalRight').value
                            )
                          "
                          [disabled]="rxProcessRole"
                          formControlName="isOvalRight"
                          [tabIndex]="37"
                          >Oval</mat-checkbox
                        >
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="ovalWidthRight"
                              text="{{
                                bothSidesForm.get('isOvalRight').value
                                  ? 'WIDTH *'
                                  : 'WIDTH'
                              }}"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #ovalWidthRight
                              [step]="1"
                              id="ovalWidthRight"
                              [min]="48"
                              [readonly]="rxProcessRole"
                              [max]="80"
                              [format]="'n0'"
                              [tabIndex]="38"
                              class="w-100"
                              formControlName="ovalWidthRight"
                              (blur)="
                                validateOvalHeight(
                                  'ovalWidthRight',
                                  'ovalHeightRight'
                                )
                              "
                              [rangeValidation]="false"
                              placeholder="{{
                                bothSidesForm.get('isOvalRight').value
                                  ? 'WIDTH *'
                                  : 'WIDTH'
                              }}"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalWidthRight').errors
                                  ?.required
                              "
                              >value is required</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalWidthRight').errors
                                  ?.range
                              "
                              >Min: 48 & Max: 80 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalWidthRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="ovalHeightRight"
                              text="{{
                                bothSidesForm.get('isOvalRight').value
                                  ? 'HEIGHT *'
                                  : 'HEIGHT'
                              }}"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #ovalHeightRight
                              [step]="1"
                              id="ovalHeightRight"
                              [min]="50"
                              [max]="80"
                              [format]="'n0'"
                              [tabIndex]="39"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="ovalHeightRight"
                              [rangeValidation]="false"
                              placeholder="{{
                                bothSidesForm.get('isOvalRight').value
                                  ? 'HEIGHT *'
                                  : 'HEIGHT'
                              }}"
                              (blur)="
                                validateOvalHeight(
                                  'ovalWidthRight',
                                  'ovalHeightRight'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalHeightRight').errors
                                  ?.required
                              "
                              >value is required</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalHeightRight').errors
                                  ?.range
                              "
                              >Min: 50 & Max: 80 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalHeightRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalHeightRight').errors
                                  ?.inValidHeight
                              "
                              >HEIGHT not allowed greater then
                              WIDTH</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="ipdr"
                              text="{{ isTailorMade ? 'IPDR *' : 'IPDR' }}"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #ipdr
                              [step]="0.1"
                              [min]="15"
                              [max]="40"
                              [format]="'n1'"
                              [tabIndex]="40"
                              class="w-100"
                              formControlName="ipdr"
                              [rangeValidation]="false"
                              placeholder="{{ isTailorMade ? 'IPDR *' : 'IPDR' }}"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="validatedrequiredRoleForIPDR && bothSidesForm.get('ipdr').errors?.required"
                              >value is required</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('ipdr').errors?.range"
                              >Min: 15 & Max: 40 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ipdr').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="rhft"
                              text="{{ isTailorMade ? 'RFH *' : 'RFH' }}"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #rhft
                              [step]="0.1"
                              [min]="10"
                              [max]="40"
                              [format]="'n1'"
                              [tabIndex]="41"
                              class="w-100"
                              formControlName="rhft"
                              [rangeValidation]="false"
                              placeholder="{{ isTailorMade ? 'RFH *' : 'RFH' }}"
                              (blur)="setFittingValue('rhft')"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('rhft').errors?.required"
                              >value is required</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('rhft').errors?.range"
                              >Min: 10 & Max: 40 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('rhft').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                    </div>
                    <!-- ADDITIONAL REQUIREMENT -->
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-heading">ADDITIONAL REQUIREMENT</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="baseCurveRight"
                              text="Base Curve"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #baseCurveRight
                              id="baseCurveRight"
                              [min]="0.5"
                              [step]="0.5"
                              [max]="10"
                              [format]="'n1'"
                              [tabIndex]="42"
                              SignNotAllowed="43"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="baseCurveRight"
                              [rangeValidation]="false"
                              placeholder="Base Curve"
                              (valueChange)="
                                validateZeroValue('baseCurveRight')
                              "
                              (blur)="
                              getRightBaseCurvePrice(
                                  bothSidesForm.get('baseCurveRight').value,
                                  customerId,
                                  'baseCurveRight'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('baseCurveRight').errors
                                  ?.range
                              "
                              >Min: 0.5 & Max: 10 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('baseCurveRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                            *ngIf="baseCurveRightPriceRole"
                            >Price is required</kendo-formerror
                          >

                            
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="etRight"
                              text="ET"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #etRight
                              id="etRight"
                              [min]="0.3"
                              [max]="5"
                              [step]="0.1"
                              [format]="'n1'"
                              [tabIndex]="43"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="etRight"
                              [rangeValidation]="false"
                              placeholder="ET"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('etRight').value,
                                  'etRight',
                                  'ctRight'
                                );
                                validateZeroValue('etRight')
                              "
                              (blur)="
                              getRightETPrice(
                                  bothSidesForm.get('etRight').value,
                                  customerId
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('etRight').errors?.range"
                              >Min: 0.3 & Max: 5 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('etRight').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="etRightPriceRole"
                              >Price is required</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="ctRight"
                              text="CT"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #ctRight
                              id="ctRight"
                              [min]="1.0"
                              [max]="10"
                              [step]="0.1"
                              [format]="'n1'"
                              [tabIndex]="44"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="ctRight"
                              [rangeValidation]="false"
                              placeholder="CT"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('ctRight').value,
                                  'ctRight',
                                  'etRight'
                                );
                                validateZeroValue('ctRight')
                              "
                              (blur)="
                              getRightCTPrice(
                                  bothSidesForm.get('ctRight').value,
                                  customerId
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('ctRight').errors?.range"
                              >Min: 1.0 & Max: 10 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ctRight').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="ctRightPriceRole"
                              >Price is required</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div
                        class="col-md-2 d-flex align-items-center justify-content-center"
                      >
                        <div
                          class="dx-field p-0 d-flex align-items-center justify-content-center"
                        >
                          Decentration:
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="decinRight"
                              text="IN"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #decinRight
                              id="decinRight"
                              [step]="1"
                              [min]="1"
                              [max]="10"
                              [format]="'n0'"
                              [tabIndex]="45"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="decinRight"
                              [rangeValidation]="false"
                              placeholder="IN"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('decinRight').value,
                                  'decinRight',
                                  'decoutRight'
                                );
                                validateZeroValue('decinRight')
                              "
                              (blur)="
                              getRightDecentrationPrice(
                                  bothSidesForm.get('decinRight').value,
                                  customerId
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('decinRight').errors?.range
                              "
                              >Min: 1 & Max: 10 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('decinRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="decentrationInRightPriceRole"
                              >Price not found...</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="decoutRight"
                              text="OUT"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #decoutRight
                              id="decoutRight"
                              [step]="1"
                              [min]="1"
                              [max]="10"
                              [format]="'n0'"
                              [tabIndex]="46"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="decoutRight"
                              [rangeValidation]="false"
                              placeholder="OUT"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('decoutRight').value,
                                  'decoutRight',
                                  'decinRight'
                                );
                                validateZeroValue('decoutRight')
                              "
                              (blur)="
                              getRightDecentrationPrice(
                                  bothSidesForm.get('decoutRight').value,
                                  customerId
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('decoutRight').errors?.range
                              "
                              >Min: 1 & Max: 10 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('decoutRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="decentrationOutRightPriceRole"
                              >Price not found...</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                    </div>
                    <!-- / ADDITIONAL REQUIREMENT -->
                    <!-- PRISM -->
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-heading">PRISM</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismInRight"
                              text="IN"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismInRight
                              id="prismInRight"
                              [step]="0.25"
                              [min]="0.5"
                              [max]="18"
                              [format]="'n2'"
                              [tabIndex]="47"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismInRight"
                              [rangeValidation]="false"
                              placeholder="IN"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('prismInRight').value,
                                  'prismInRight',
                                  'prismOutRight'
                                );
                                validateZeroValue('prismInRight')
                              "
                              (blur)="
                                getPricing(
                                  bothSidesForm.get('prismInRight').value,
                                  'prismInRight',
                                  'prismOutRight'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismInRight').errors?.range
                              "
                              >Min: 0.5 & Max: 18 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismInRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror *ngIf="prismInRightPriceRole">Price not found...</kendo-formerror>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismOutRight"
                              text="OUT"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismOutRight
                              id="prismOutRight"
                              [step]="0.25"
                              [min]="0.5"
                              [max]="18"
                              [format]="'n2'"
                              [tabIndex]="48"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismOutRight"
                              [rangeValidation]="false"
                              placeholder="OUT"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('prismOutRight').value,
                                  'prismOutRight',
                                  'prismInRight'
                                );
                                validateZeroValue('prismOutRight')
                              "
                              (blur)="
                                getPricing(
                                  bothSidesForm.get('prismOutRight').value,
                                  'prismOutRight',
                                  'prismInRight'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismOutRight').errors?.range
                              "
                              >Min: 0.5 & Max: 18 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismOutRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror *ngIf="prismOutRightPriceRole">Price not found...</kendo-formerror>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismUpRight"
                              text="UP"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismUpRight
                              id="prismUpRight"
                              [step]="0.25"
                              [min]="0.5"
                              [max]="18"
                              [format]="'n2'"
                              [tabIndex]="49"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismUpRight"
                              [rangeValidation]="false"
                              placeholder="UP"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('prismUpRight').value,
                                  'prismUpRight',
                                  'prismDownRight'
                                );
                                validateZeroValue('prismUpRight')
                              "
                              (blur)="
                                getPricing(
                                  bothSidesForm.get('prismUpRight').value,
                                  'prismUpRight',
                                  'prismDownRight'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismUpRight').errors?.range
                              "
                              >Min: 0.5 & Max: 18 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismUpRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror *ngIf="prismUpRightPriceRole">Price not found...</kendo-formerror>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismDownRight"
                              text="DOWN"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismDownRight
                              id="prismDownRight"
                              [step]="0.25"
                              [min]="0.5"
                              [max]="18"
                              [format]="'n2'"
                              [tabIndex]="50"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismDownRight"
                              [rangeValidation]="false"
                              placeholder="DOWN"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('prismDownRight').value,
                                  'prismDownRight',
                                  'prismUpRight'
                                );
                                validateZeroValue('prismDownRight')
                              "
                              (blur)="
                                getPricing(
                                  bothSidesForm.get('prismDownRight').value,
                                  'prismDownRight',
                                  'prismUpRight'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismDownRight').errors
                                  ?.range
                              "
                              >Min: 0.5 & Max: 18 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismDownRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror *ngIf="prismDownRightPriceRole">Price not found...</kendo-formerror>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismValueRight"
                              text="VALUE"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismValueRight
                              id="prismValueRight"
                              [step]="0.25"
                              [min]="0.5"
                              [max]="18"
                              [format]="'n2'"
                              [tabIndex]="51"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismValueRight"
                              [rangeValidation]="false"
                              placeholder="VALUE"
                              (valueChange)="
                                checkValue($event, 'prismValueRight');
                                validateZeroValue('prismValueRight')
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismValueRight').errors
                                  ?.range
                              "
                              >Min: 0.5 & Max: 18 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismValueRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror *ngIf="prismValueRightPriceRole">Price not found...</kendo-formerror>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismAxisRight"
                              text="AXIS"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismAxisRight
                              id="prismAxisRight"
                              [step]="1"
                              [min]="0"
                              [max]="360"
                              [format]="'n0'"
                              [tabIndex]="52"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismAxisRight"
                              [rangeValidation]="false"
                              placeholder="AXIS"
                              (valueChange)="
                                checkValue($event, 'prismAxisRight');
                                validateZeroValue('prismAxisRight')
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismAxisRight').errors
                                  ?.range
                              "
                              >Min: 0.5 & Max: 16 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismAxisRight').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismAxisRight').errors
                                  ?.required
                              "
                              >value is required</kendo-formerror
                            >
                            <!-- <kendo-formerror *ngIf="prismAxisRightPriceRole">Price not found...</kendo-formerror> -->
                          </kendo-formfield>
                        </div>
                      </div>
                    </div>
                    <!-- / PRISM -->
                  </div>
                </app-panel>
              </div>
              <!--/ RIGHT RX INFORMATION -->
              <!-- LEFT RX INFORMATION -->
              <div class="col-md-6">
                <app-panel [backArrow]="false">
                  <div class="heading">Left RX Information</div>
                  <div class="body">
                    <div class="row">
                      <div class="col-md-2 position-relative" id="sphLeft">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="sphLeft"
                              text="SPH"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              (focus)="tempValidate('sphLeft')"
                              [clearButton]="false"
                              #sphLeft
                              class="w-100"
                              [loading]="loadingSphRange"
                              formControlName="sphLeft"
                              [valuePrimitive]="true"
                              [data]="sphRangeList"
                              [readonly]="rxProcessRole"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [valueField]="'sphValue'"
                              [textField]="'sphValue'"
                              [suggest]="true"
                              (valueChange)="
                                getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphLeft').value,
                                  bothSidesForm.get('cylLeft').value,
                                  bothSidesForm.get('addfLeft').value,
                                  'left',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterLeft').value,
                                  bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                );getLeftCYL(selectedItemCatalogObject.cylMinExt, selectedItemCatalogObject.cylMaxExt)

                              "
                              [placeholder]="'SPH'"
                              [tabIndex]="53"
                            >
                            </kendo-combobox>
                          </kendo-formfield>
                          <dx-tooltip
                            target="#sphLeft"
                            [visible]="sphLeftTooltip"
                            [hideOnOutsideClick]="false"
                          >
                            <div
                              *dxTemplate="let data = data; of: 'content'"
                              style="font-size: 14px; color: rgb(217, 83, 79)"
                            >
                              SPH value is required
                            </div>
                          </dx-tooltip>
                        </div>
                      </div>
                      <div class="col-md-2 position-relative" id="cylLeft">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="cylLeft"
                              text="CYL"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              (focus)="tempValidate('cylLeft')"
                              [clearButton]="false"
                              #cylLeft
                              class="w-100"
                              [loading]="loadingCylRange"
                              formControlName="cylLeft"
                              [valuePrimitive]="true"
                              [data]="leftCylRangeList"
                              [readonly]="rxProcessRole"
                              [valueField]="'cylValue'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [textField]="'cylValue'"
                              (valueChange)="
                                getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphLeft').value,
                                  bothSidesForm.get('cylLeft').value,
                                  bothSidesForm.get('addfLeft').value,
                                  'left',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterLeft').value,
                                  bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                )
                              "
                              [suggest]="true"
                              [placeholder]="'CYL'"
                              [tabIndex]="54"
                            >
                            </kendo-combobox>
                          </kendo-formfield>
                          <dx-tooltip
                            target="#cylLeft"
                            [visible]="cylLeftTooltip"
                            [hideOnOutsideClick]="false"
                          >
                            <div
                              *dxTemplate="let data = data; of: 'content'"
                              style="font-size: 14px; color: rgb(217, 83, 79)"
                            >
                              CYL value is required
                            </div>
                          </dx-tooltip>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="axisLeft"
                              text="{{ validateAxisLeft ? 'AXIS *' : 'AXIS' }}"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #axisLeft
                              [step]="1"
                              NumberValidate
                              [min]="1"
                              [max]="180"
                              [tabIndex]="55"
                              [format]="'n0'"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              SignNotAllowed="43"
                              [rangeValidation]="false"
                              (valueChange)="validateZeroValue('axisLeft')"
                              formControlName="axisLeft"
                              placeholder="{{
                                validateAxisLeft ? 'AXIS *' : 'AXIS'
                              }}"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('axisLeft').errors?.required
                              "
                              >value is required</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('axisLeft').errors?.range
                              "
                              >Min: 1 & Max: 180 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('axisLeft').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                        <!-- <mat-form-field class="w-100">
                              <input
                                type="number"
                                id="axisLeft"
                                SignNotAllowed="43"
                                (input)="validateZeroValue('axisLeft')"
                                matInput
                                formControlName="axisLeft"
                                NumberValidate
                                placeholder="{{ validateAxisLeft ? 'AXIS *' : 'AXIS' }}"
                                step="1"
                                min="1"
                                max="180"
                                autocomplete="off"
                                [tabIndex]="37"
                              />
                            </mat-form-field>
                            <dx-tooltip
                              target="#axisLeft"
                              [visible]="
                                bothSidesForm.get('axisLeft').errors &&
                                bothSidesForm.get('axisLeft').touched
                              "
                              [hideOnOutsideClick]="false"
                            >
                              <div
                                *dxTemplate="let data = data; of: 'content'"
                                style="font-size: 14px; color: rgb(217, 83, 79)"
                              >
                                {{
                                  bothSidesForm.get("axisLeft").errors?.range
                                    ? "Axis Min: 1 & Max: 180 allowed"
                                    : ""
                                }}
                                {{
                                  bothSidesForm.get("axisLeft").errors?.stepError
                                    ? "Axis value is not valid"
                                    : ""
                                }}
                                {{
                                  bothSidesForm.get("axisLeft").errors?.required
                                    ? "Axis value is required"
                                    : ""
                                }}
                              </div>
                            </dx-tooltip> -->
                      </div>
                      <div class="col-md-2 position-relative" id="addfLeft">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="addfLeft"
                              text="ADD"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              (focus)="tempValidate('addfLeft')"
                              [clearButton]="false"
                              #addfLeft
                              class="w-100"
                              [loading]="loadingAddfRange"
                              formControlName="addfLeft"
                              [readonly]="rxProcessRole"
                              [valuePrimitive]="true"
                              [data]="addfRangeList"
                              [valueField]="'addfValue'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [textField]="'addfValue'"
                              [suggest]="true"
                              (valueChange)="
                                getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphLeft').value,
                                  bothSidesForm.get('cylLeft').value,
                                  bothSidesForm.get('addfLeft').value,
                                  'left',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterLeft').value,
                                  bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                )
                              "
                              [placeholder]="'ADD'"
                              [tabIndex]="56"
                            >
                            </kendo-combobox>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="qtyLeftLabel"
                              text="QTY *"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              NumberValidate
                              #qtyLeftLabel
                              [step]="1"
                              [min]="1"
                              [format]="'n0'"
                              (valueChange)="
                                validateZeroValue('qtyLeft'); getRightQtyRole(); warringMsg(bothSidesForm.get('qtyRight').value)
                              "
                              class="w-100"
                              [tabIndex]="57"
                              formControlName="qtyLeft"
                              (blur)="
                                getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphLeft').value,
                                  bothSidesForm.get('cylLeft').value,
                                  bothSidesForm.get('addfLeft').value,
                                  'left',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterLeft').value,
                                  bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                );updateLensePriceForCombo(selectedTemplate)
                              "
                              placeholder="QTY *"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror>value is required</kendo-formerror>
                          </kendo-formfield>
                        </div>
                        <!-- ;getRightQtyRole() -->
                        <!-- <mat-form-field class="w-100">
                              <input
                                type="number"
                                id="qtyLeft"
                                NumberValidate
                                matInput
                                min="1"
                                (input)="validateZeroValue('qtyLeft')"
                                formControlName="qtyLeft"
                                (focusout)="addLensePrice('left'); getLeftFnPrice(customerBranchId,selectedItemCatalogObject?.itemCatalogGroupId, 
                                bothSidesForm.get('sphLeft').value ? bothSidesForm.get('sphLeft').value : 0, 
                                bothSidesForm.get('cylLeft').value ? bothSidesForm.get('cylLeft').value : 0, 
                                bothSidesForm.get('addfLeft').value ? bothSidesForm.get('addfLeft').value : 0, 'left')"
                                placeholder="QTY *"
                                autocomplete="off"
                                [tabIndex]="39"
                              />
                            </mat-form-field> -->
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="diameterLeft"
                              text="DIAMETER *"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #diameterLeft
                              [step]="1"
                              [format]="'n0'"
                              [min]="48"
                              [max]="80"
                              [readonly]="rxProcessRole"
                              [tabIndex]="58"
                              [rangeValidation]="false"
                              (valueChange)="validateZeroValue('diameterLeft')"
                              class="w-100"
                              formControlName="diameterLeft"
                              (blur)="
                                disableOvalLeftCheckBox(
                                  bothSidesForm.get('diameterLeft').value
                                );
                                getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphLeft').value,
                                  bothSidesForm.get('cylLeft').value,
                                  bothSidesForm.get('addfLeft').value,
                                  'left',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterLeft').value,
                                  bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                )
                              "
                              placeholder="DIAMETER *"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror>value is required</kendo-formerror>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('diameterLeft').errors?.range
                              "
                              >Min: 48 & Max: 80 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('diameterLeft').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                        <!-- <mat-form-field class="w-100">
                              <input
                                type="number"
                                id="diameterLeft"
                                matInput
                                formControlName="diameterLeft"
                                placeholder="DIAMETER *"
                                (input)="validateZeroValue('diameterLeft')"
                                step="1"
                                autocomplete="off"
                                min="48"
                                max="80"
                                (keyup)="
                                  disableOvalLeftCheckBox(
                                    bothSidesForm.get('diameterLeft').value
                                  )
                                "
                                [tabIndex]="40"
                              />
                            </mat-form-field>
                            <dx-tooltip
                              target="#diameterLeft"
                              [visible]="
                                bothSidesForm.get('diameterLeft').errors &&
                                bothSidesForm.get('diameterLeft').touched
                              "
                              [hideOnOutsideClick]="false"
                            >
                              <div
                                *dxTemplate="let data = data; of: 'content'"
                                style="font-size: 14px; color: rgb(217, 83, 79)"
                              >
                                {{
                                  bothSidesForm.get("diameterLeft").errors?.range
                                    ? "DIAMETER Min: 48 & Max: 80 allowed"
                                    : ""
                                }}
                                {{
                                  bothSidesForm.get("diameterLeft").errors?.stepError
                                    ? "DIAMETER value is not valid"
                                    : ""
                                }}
                                {{
                                  bothSidesForm.get("diameterLeft").errors?.required
                                    ? "DIAMETER is required"
                                    : ""
                                }}
                              </div>
                            </dx-tooltip> -->
                      </div>
                      <div
                        class="col-md-2 d-flex align-items-center justify-content-center"
                      >
                        <mat-checkbox
                          color="primary"
                          (change)="
                            isOvalLeftChange(
                              bothSidesForm.get('isOvalLeft').value
                            )
                          "
                          [disabled]="rxProcessRole"
                          formControlName="isOvalLeft"
                          [tabIndex]="59"
                          >Oval</mat-checkbox
                        >
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="ovalWidthLeft"
                              text="{{
                                bothSidesForm.get('isOvalLeft').value
                                  ? 'WIDTH *'
                                  : 'WIDTH'
                              }}"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #ovalWidthLeft
                              [step]="1"
                              id="ovalWidthLeft"
                              [min]="48"
                              [readonly]="rxProcessRole"
                              [max]="80"
                              [format]="'n0'"
                              [tabIndex]="60"
                              class="w-100"
                              formControlName="ovalWidthLeft"
                              [rangeValidation]="false"
                              (blur)="
                                validateOvalHeight(
                                  'ovalWidthLeft',
                                  'ovalHeightLeft'
                                )
                              "
                              placeholder="{{
                                bothSidesForm.get('isOvalLeft').value
                                  ? 'WIDTH *'
                                  : 'WIDTH'
                              }}"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalWidthLeft').errors
                                  ?.required
                              "
                              >value is required</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalWidthLeft').errors?.range
                              "
                              >Min: 48 & Max: 80 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalWidthLeft').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="ovalHeightLeft"
                              text="{{
                                bothSidesForm.get('isOvalLeft').value
                                  ? 'HEIGHT *'
                                  : 'HEIGHT'
                              }}"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #ovalHeightLeft
                              [step]="1"
                              id="ovalHeightLeft"
                              [min]="48"
                              [max]="80"
                              [format]="'n0'"
                              [tabIndex]="61"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="ovalHeightLeft"
                              [rangeValidation]="false"
                              placeholder="{{
                                bothSidesForm.get('isOvalLeft').value
                                  ? 'HEIGHT *'
                                  : 'HEIGHT'
                              }}"
                              (blur)="
                                validateOvalHeight(
                                  'ovalWidthLeft',
                                  'ovalHeightLeft'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalHeightLeft').errors
                                  ?.required
                              "
                              >value is required</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalHeightLeft').errors
                                  ?.range
                              "
                              >Min: 48 & Max: 80 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalHeightLeft').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ovalHeightLeft').errors
                                  ?.inValidHeight
                              "
                              >HEIGHT not allowed greater then
                              WIDTH</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="ipdl"
                              text="{{ isTailorMade ? 'IPDL *' : 'IPDL' }}"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #ipdl
                              [step]="0.1"
                              [min]="15"
                              [max]="40"
                              [format]="'n1'"
                              [readonly]="rxProcessRole"
                              [tabIndex]="62"
                              class="w-100"
                              formControlName="ipdl"
                              [rangeValidation]="false"
                              placeholder="{{ isTailorMade ? 'IPDL *' : 'IPDL' }}"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="validatedrequiredRoleForIPDL && bothSidesForm.get('ipdl').errors?.required"
                              >value is required</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('ipdl').errors?.range"
                              >Min: 15 & Max: 40 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ipdl').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                        <!-- <mat-form-field class="w-100">
                              <input
                                formControlName="ipdl"
                                type="number"
                                id="ipdl"
                                matInput
                                placeholder="{{ isTailorMade ? 'IPDL *' : 'IPDL' }}"
                                min="15"
                                max="40"
                                step="0.1"
                                [ToFixedDirective]="1"
                                [tabIndex]="41"
                              />
                            </mat-form-field>
                            <dx-tooltip
                              target="#ipdl"
                              [visible]="
                                bothSidesForm.get('ipdl').errors &&
                                bothSidesForm.get('ipdl').touched
                              "
                              [hideOnOutsideClick]="false"
                            >
                              <div
                                *dxTemplate="let data = data; of: 'content'"
                                style="font-size: 14px; color: rgb(217, 83, 79)"
                              >
                                {{
                                  bothSidesForm.get("ipdl").errors?.range
                                    ? "IPDL Min: 15 & Max: 40 allowed"
                                    : ""
                                }}
                                {{
                                  bothSidesForm.get("ipdl").errors?.stepError
                                    ? "IPDL value is not valid"
                                    : ""
                                }}
                                {{
                                  bothSidesForm.get("ipdl").errors?.required
                                    ? "IPDL is required"
                                    : ""
                                }}
                              </div>
                            </dx-tooltip> -->
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="lhft"
                              text="{{ isTailorMade ? 'LFH *' : 'LFH' }}"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #lhft
                              [step]="0.1"
                              [min]="10"
                              [max]="40"
                              [tabIndex]="63"
                              [readonly]="rxProcessRole"
                              [format]="'n1'"
                              class="w-100"
                              [rangeValidation]="false"
                              formControlName="lhft"
                              (blur)="setFittingValue('lhft')"
                              placeholder="{{ isTailorMade ? 'LFH *' : 'LFH' }}"
                            >
                            </kendo-numerictextbox>
                            <!-- <kendo-formerror *ngIf="bothSidesForm.get('lhft').errors?.required">value is required</kendo-formerror> -->
                            <kendo-formerror
                              *ngIf="
                                (bothSidesForm.controls.lhft.touched ||
                                  bothSidesForm.controls.lhft.dirty) &&
                                bothSidesForm.controls.lhft.errors?.range
                              "
                              >Min: 10 & Max: 40 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                (bothSidesForm.controls.lhft.touched ||
                                  bothSidesForm.controls.lhft.dirty) &&
                                bothSidesForm.controls.lhft.errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                        <!-- <mat-form-field class="w-100">
                            <input
                              type="number"
                              matInput
                              id="lhft"
                              placeholder="{{ isTailorMade ? 'LHF *' : 'LHF' }}"
                              formControlName="lhft"
                              step="0.1"
                              autocomplete="off"
                              min="10"
                              max="40"
                              [ToFixedDirective]="1"
                              (focusout)="setFittingValue('lhft')"
                              [tabIndex]="44"
                            />
                          </mat-form-field>
                          <dx-tooltip
                            target="#lhft"
                            [visible]="
                              bothSidesForm.get('lhft').errors &&
                              bothSidesForm.get('lhft').touched
                            "
                            [hideOnOutsideClick]="false"
                          >
                            <div
                              *dxTemplate="let data = data; of: 'content'"
                              style="font-size: 14px; color: rgb(217, 83, 79)"
                            >
                              {{
                                bothSidesForm.get("lhft").errors?.range
                                  ? "LHF Min: 10 & Max: 35 allowed"
                                  : ""
                              }}
                              {{
                                bothSidesForm.get("lhft").errors?.stepError
                                  ? "LHF value is not valid"
                                  : ""
                              }}
                            </div>
                          </dx-tooltip> -->
                      </div>
                    </div>
                    <!-- ADDITIONAL REQUIREMENT -->
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-heading">ADDITIONAL REQUIREMENT</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="baseCurveLeft"
                              text="Base Curve"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #baseCurveLeft
                              id="baseCurveLeft"
                              [min]="0.5"
                              [step]="0.5"
                              [max]="10"
                              [format]="'n1'"
                              [tabIndex]="64"
                              SignNotAllowed="43"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="baseCurveLeft"
                              [rangeValidation]="false"
                              placeholder="Base Curve"
                              (valueChange)="validateZeroValue('baseCurveLeft')"
                              (blur)="
                              getLeftBaseCurvePrice(
                                  bothSidesForm.get('baseCurveLeft').value,
                                  customerId,
                                  'baseCurveLeft'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('baseCurveLeft').errors?.range
                              "
                              >Min: 0.5 & Max: 10 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('baseCurveLeft').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror *ngIf="baseCurveLeftPriceRole"
                              >Price is required</kendo-formerror>
                            
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label [for]="etLeft" text="ET"></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #etLeft
                              id="etLeft"
                              [min]="0.3"
                              [max]="5"
                              [step]="0.1"
                              [format]="'n1'"
                              [tabIndex]="65"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="etLeft"
                              [rangeValidation]="false"
                              placeholder="ET"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('etLeft').value,
                                  'etLeft',
                                  'ctLeft'
                                );
                                validateZeroValue('etLeft')
                              "
                              (blur)="
                              getLeftETPrice(bothSidesForm.get('etLeft').value,customerId)
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('etLeft').errors?.range"
                              >Min: 0.3 & Max: 5 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('etLeft').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="etLeftPriceRole"
                              >Price is required</kendo-formerror
                            >
                            
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label [for]="ctLeft" text="CT"></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #ctLeft
                              id="ctLeft"
                              [min]="1.0"
                              [max]="10"
                              [step]="0.1"
                              [format]="'n1'"
                              [tabIndex]="66"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="ctLeft"
                              [rangeValidation]="false"
                              placeholder="CT"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('ctLeft').value,
                                  'ctLeft',
                                  'etLeft'
                                );
                                validateZeroValue('ctLeft')
                              "
                              (blur)="
                              getLeftCTPrice(
                                  bothSidesForm.get('ctLeft').value,
                                  customerId
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('ctLeft').errors?.range"
                              >Min: 1.0 & Max: 10 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('ctLeft').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="ctLeftPriceRole"
                              >Price is required</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div
                        class="col-md-2 d-flex align-items-center justify-content-center"
                      >
                        <div
                          class="dx-field p-0 d-flex align-items-center justify-content-center"
                        >
                          Decentration:
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="decinLeft"
                              text="IN"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #decinLeft
                              id="decinLeft"
                              [step]="1"
                              [min]="1"
                              [max]="10"
                              [format]="'n0'"
                              [tabIndex]="67"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="decinLeft"
                              [rangeValidation]="false"
                              placeholder="IN"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('decinLeft').value,
                                  'decinLeft',
                                  'decoutLeft'
                                );
                                validateZeroValue('decinLeft')
                              "
                              (blur)="
                              getLeftDecentrationPrice(
                                  bothSidesForm.get('decinLeft').value,
                                  customerId
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('decinLeft').errors?.range
                              "
                              >Min: 1 & Max: 10 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('decinLeft').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="decentrationInLeftPriceRole"
                              >Price not found</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="decoutLeft"
                              text="OUT"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #decoutLeft
                              id="decoutLeft"
                              [step]="1"
                              [min]="1"
                              [max]="10"
                              [format]="'n0'"
                              [tabIndex]="68"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="decoutLeft"
                              [rangeValidation]="false"
                              placeholder="OUT"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('decoutLeft').value,
                                  'decoutLeft',
                                  'decinLeft'
                                );
                                validateZeroValue('decoutLeft')
                              "
                              (blur)="
                              getLeftDecentrationPrice(
                                  bothSidesForm.get('decoutLeft').value,
                                  customerId
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('decoutLeft').errors?.range
                              "
                              >Min: 1 & Max: 10 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('decoutLeft').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="decentrationOutLeftPriceRole"
                              >Price not found</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                    </div>
                    <!-- / ADDITIONAL REQUIREMENT -->
                    <!-- PRISM -->
                    <div class="row">
                      <div class="col-md-12">
                        <div class="sub-heading">PRISM</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismInLeft"
                              text="IN"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismInLeft
                              id="prismInLeft"
                              [step]="0.25"
                              [min]="0.5"
                              [max]="18"
                              [format]="'n2'"
                              [tabIndex]="69"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismInLeft"
                              [rangeValidation]="false"
                              placeholder="IN"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('prismInLeft').value,
                                  'prismInLeft',
                                  'prismOutLeft'
                                );
                                validateZeroValue('prismInLeft')
                              "
                              (blur)="
                                getPricing(
                                  bothSidesForm.get('prismInLeft').value,
                                  'prismInLeft',
                                  'prismOutLeft'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismInLeft').errors?.range
                              "
                              >Min: 0.5 & Max: 18 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismInLeft').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror *ngIf="prismInLeftPriceRole">Price not found...</kendo-formerror>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismOutLeft"
                              text="OUT"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismOutLeft
                              id="prismOutLeft"
                              [step]="0.25"
                              [min]="0.5"
                              [max]="18"
                              [format]="'n2'"
                              [tabIndex]="70"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismOutLeft"
                              [rangeValidation]="false"
                              placeholder="OUT"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('prismOutLeft').value,
                                  'prismOutLeft',
                                  'prismInLeft'
                                );
                                validateZeroValue('prismOutLeft')
                              "
                              (blur)="
                                getPricing(
                                  bothSidesForm.get('prismOutLeft').value,
                                  'prismOutLeft',
                                  'prismInLeft'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismOutLeft').errors?.range
                              "
                              >Min: 0.5 & Max: 18 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismOutLeft').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror *ngIf="prismOutLeftPriceRole">Price not found...</kendo-formerror>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismUpLeft"
                              text="UP"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismUpLeft
                              id="prismUpLeft"
                              [step]="0.25"
                              [min]="0.5"
                              [max]="18"
                              [format]="'n2'"
                              [tabIndex]="71"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismUpLeft"
                              [rangeValidation]="false"
                              placeholder="UP"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('prismUpLeft').value,
                                  'prismUpLeft',
                                  'prismDownLeft'
                                );
                                validateZeroValue('prismUpLeft')
                              "
                              (blur)="
                                getPricing(
                                  bothSidesForm.get('prismUpLeft').value,
                                  'prismUpLeft',
                                  'prismDownLeft'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismUpLeft').errors?.range
                              "
                              >Min: 0.5 & Max: 18 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismUpLeft').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror *ngIf="prismUpLeftPriceRole">Price not found...</kendo-formerror>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismDownLeft"
                              text="DOWN"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismDownLeft
                              id="prismDownLeft"
                              [step]="0.25"
                              [min]="0.5"
                              [max]="18"
                              [format]="'n2'"
                              [tabIndex]="72"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismDownLeft"
                              [rangeValidation]="false"
                              placeholder="DOWN"
                              (valueChange)="
                                checkETCt(
                                  bothSidesForm.get('prismDownLeft').value,
                                  'prismDownLeft',
                                  'prismUpLeft'
                                );
                                validateZeroValue('prismDownLeft')
                              "
                              (blur)="
                                getPricing(
                                  bothSidesForm.get('prismDownLeft').value,
                                  'prismDownLeft',
                                  'prismUpLeft'
                                )
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismDownLeft').errors?.range
                              "
                              >Min: 0.5 & Max: 18 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismDownLeft').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror *ngIf="prismDownLeftPriceRole">Price not found...</kendo-formerror>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismValueLeft"
                              text="VALUE"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismValueLeft
                              id="prismValueLeft"
                              [step]="0.25"
                              [min]="0.5"
                              [max]="18"
                              [format]="'n2'"
                              [tabIndex]="73"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismValueLeft"
                              [rangeValidation]="false"
                              placeholder="VALUE"
                              (valueChange)="
                                checkValue($event, 'prismValueLeft');
                                validateZeroValue('prismValueLeft')
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismValueLeft').errors
                                  ?.range
                              "
                              >Min: 0.5 & Max: 18 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismValueLeft').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror *ngIf="prismValueLeftPriceRole">Price not found...</kendo-formerror>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="prismAxisLeft"
                              text="AXIS"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #prismAxisLeft
                              id="prismAxisLeft"
                              [step]="1"
                              [min]="0"
                              [max]="360"
                              [format]="'n0'"
                              [tabIndex]="74"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="prismAxisLeft"
                              [rangeValidation]="false"
                              placeholder="AXIS"
                              (valueChange)="
                                checkValue($event, 'prismAxisLeft');
                                validateZeroValue('prismAxisLeft')
                              "
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismAxisLeft').errors?.range
                              "
                              >Min: 0.5 & Max: 16 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismAxisLeft').errors
                                  ?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('prismAxisLeft').errors
                                  ?.required
                              "
                              >value is required</kendo-formerror
                            >
                            <!-- <kendo-formerror *ngIf="prismAxisLeftPriceRole">Price not found...</kendo-formerror> -->
                          </kendo-formfield>
                        </div>
                      </div>
                    </div>
                    <!-- / PRISM -->
                  </div>
                </app-panel>
              </div>
              <!--/ LEFT RX INFORMATION -->
            </div>
            <!--/ RX INFORMATION -->
            <div class="mt-3 mb-3"></div>
            <!-- FRAME INFORMATION -->
            <ng-container *ngIf="isFitting || isTailorMade">
            <app-panel [backArrow]="false" [footer]="false" #frame>
              <div class="heading">Frame Information</div>
                <div class="body">
                  <div class="row">
                    
                   
                      <div class="col-md-2"  *ngIf="isFitting">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="fittingTypeId"
                              text="{{isFitting ? 'Fitting Type *' : 'Fitting Type'}}"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              [clearButton]="false"
                              #fittingTypeId
                              [tabIndex]="75"
                              [readonly]="getFittingProcessRole"
                              class="w-100"
                              formControlName="fittingTypeId"
                              [valuePrimitive]="true"
                              [data]="fittingList"
                              [valueField]="'fittingTypeId'"
                              [textField]="'fittingTypeName'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [suggest]="true"
                              placeholder="{{isFitting ? 'Choose Fitting Type *' : 'Choose Fitting Type'}}"
                            >
                            </kendo-combobox>
                            <kendo-formerror
                              >Fitting Type is required</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2" *ngIf="isTailorMade || isFitting">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="frameType"
                              text="{{(isFitting || isTailorMade) ? 'Frame Type *' : 'Frame Type'}}"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              [clearButton]="false"
                              #frameType
                              [tabIndex]="76"
                              [readonly]="getFittingProcessRole"
                              class="w-100"
                              formControlName="frameType"
                              [valuePrimitive]="true"
                              [data]="allFrameType"
                              [valueField]="'frameId'"
                              [textField]="'frameName'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [suggest]="true"
                              (valueChange)="
                                getEdgingPrice(
                                  selectedItemCatalogObject?.brandMasterId,
                                  bothSidesForm.get('customerBranchId').value,
                                  selectedItemCatalogObject?.indexId,
                                  selectedItemCatalogObject?.materialId,
                                  bothSidesForm.get('frameType').value,
                                  bothSidesForm.get('isOurLens').value
                                )
                              "
                              placeholder="{{isFitting ? 'Choose Frame Type *' : 'Choose Frame Type'}}"
                            >
                            </kendo-combobox>
                            <kendo-formerror *ngIf="bothSidesForm.get('frameType').errors?.required">Frame Type is required</kendo-formerror>
                            <kendo-formerror
                              *ngIf="fittingTypePriceRole"
                              >Price is required</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2"  *ngIf="isFitting">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="frameConditionId"
                              text="Condition"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              [clearButton]="true"
                              #frameConditionId
                              [tabIndex]="77"
                              class="w-100"
                              formControlName="frameCondition"
                              [valuePrimitive]="true"
                              [data]="allFrameCondition"
                              [readonly]="getFittingProcessRole"
                              [valueField]="'frameConditionId'"
                              [textField]="'frameConditionName'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [suggest]="true"
                              placeholder="Choose Condition"
                            >
                            </kendo-combobox>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2"  *ngIf="isFitting">
                        <div class="dx-field hightLight">
                          <div>Frame Brand</div>
                          <dx-select-box
                            [inputAttr]="{ autocomplete: 'off' }"
                            [items]="frameBrandList"
                            #frameBrand
                            placeholder="Frame Brand"
                            [showClearButton]="false"
                            [readOnly]="getFittingProcessRole"
                            [acceptCustomValue]="true"
                            displayExpr="frameBrandName"
                            valueExpr="frameBrandName"
                            formControlName="frameBrand"
                            class="enter-keypress-focus-input"
                            (onCustomItemCreating)="onCustomItemCreating($event)"
                            [searchEnabled]="true"
                            [tabIndex]="78"
                          >
                          </dx-select-box>
                        </div>
                      </div>
                      <div class="col-md-2" *ngIf="isFitting">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label text="Model"></kendo-label>
                            <kendo-textbox
                              [readonly]="getFittingProcessRole"
                              class="w-100"
                              [tabIndex]="79"
                              formControlName="frameModel"
                              placeholder="Model"
                            >
                            </kendo-textbox>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2" *ngIf="isFitting">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="materialId"
                              text="Material"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              [clearButton]="true"
                              #materialId
                              [tabIndex]="80"
                              class="w-100"
                              [readonly]="getFittingProcessRole"
                              formControlName="frameMaterial"
                              [valuePrimitive]="true"
                              [data]="allMaterialsForFitting"
                              [valueField]="'materialId'"
                              [textField]="'materialName'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [suggest]="true"
                              placeholder="Choose Material"
                            >
                            </kendo-combobox>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2" *ngIf="isFitting">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="frameColor"
                              text="Color"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              [clearButton]="true"
                              #frameColor
                              [tabIndex]="81"
                              class="w-100"
                              [readonly]="getFittingProcessRole"
                              formControlName="frameColor"
                              [valuePrimitive]="true"
                              [data]="colorMasterList"
                              [valueField]="'colorMasterId'"
                              [textField]="'colorName'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [suggest]="true"
                              placeholder="Choose Color"
                            >
                            </kendo-combobox>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2" *ngIf="isFitting">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="frameSize"
                              text="Size"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #frameSize
                              [step]="0.1"
                              [min]="30"
                              [max]="75"
                              [tabIndex]="82"
                              [readonly]="getFittingProcessRole"
                              [format]="'n1'"
                              class="w-100"
                              formControlName="frameSize"
                              [rangeValidation]="false"
                              placeholder="Size"
                            >
                            </kendo-numerictextbox>
                            <kendo-formerror
                              *ngIf="bothSidesForm.get('frameSize').errors?.range"
                              >Min: 30 & Max: 75 allowed</kendo-formerror
                            >
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('frameSize').errors?.stepError
                              "
                              >value is not valid</kendo-formerror
                            >
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2" *ngIf="isFitting">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="companyBranchId"
                              text="Fitting Location"
                            ></kendo-label>
                            <kendo-combobox
                              [virtual]="true"
                              [clearButton]="true"
                              #companyBranchId
                              [tabIndex]="83"
                              class="w-100"
                              formControlName="fittingLocationId"
                              [valuePrimitive]="true"
                              [data]="allCompanyBranches"
                              [valueField]="'companyBranchId'"
                              [readonly]="getFittingProcessRole"
                              [textField]="'companyBranchName'"
                              [filterable]="true"
                              [kendoDropDownFilter]="{ operator: 'contains' }"
                              [suggest]="true"
                              placeholder="Choose Fitting Location"
                            >
                            </kendo-combobox>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-2" *ngIf="isFitting">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="circumference"
                              text="Circumference"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #circumference
                              [step]="0.1"
                              [tabIndex]="84"
                              [readonly]="getFittingProcessRole"
                              class="w-100"
                              [min]="1"
                              [format]="'n1'"
                              formControlName="circumference"
                              [rangeValidation]="false"
                              placeholder="Circumference"
                            >
                            </kendo-numerictextbox>
                          </kendo-formfield>
                        </div>
                      </div>
                    <div class="col-md-2" *ngIf="isFitting">
                      <div class="dx-field hightLight">
                        <kendo-formfield>
                          <kendo-label text="Lens Reference Shape"></kendo-label>
                          <kendo-textbox
                            [tabIndex]="85"
                            class="w-100"
                            [readonly]="getFittingProcessRole"
                            formControlName="lensReference"
                            placeholder="Lens Reference Shape"
                          >
                          </kendo-textbox>
                        </kendo-formfield>
                      </div>
                    </div>
                    <div class="col-md-2" *ngIf="isTailorMade || isFitting">
                      <div class="dx-field hightLight w-100">
                        <kendo-formfield>
                          <kendo-label [for]="dbl" text="DBL"></kendo-label>
                          <kendo-numerictextbox
                            [spinners]="false"
                            #dbl
                            [step]="0.1"
                            [tabIndex]="86"
                            [min]="8"
                            [max]="30"
                            [format]="'n1'"
                            [readonly]="getFittingProcessRole"
                            class="w-100"
                            formControlName="dbl"
                            [rangeValidation]="false"
                            placeholder="DBL"
                          >
                          </kendo-numerictextbox>
                          <kendo-formerror
                            *ngIf="bothSidesForm.get('dbl').errors?.required"
                            >value is required</kendo-formerror
                          >
                          <kendo-formerror
                            *ngIf="bothSidesForm.get('dbl').errors?.range"
                            >Min: 8 & Max: 30 allowed</kendo-formerror
                          >
                          <kendo-formerror
                            *ngIf="bothSidesForm.get('dbl').errors?.stepError"
                            >value is not valid</kendo-formerror
                          >
                        </kendo-formfield>
                      </div>
                    </div>
                    <div class="col-md-8" *ngIf="isTailorMade && !isFitting">
                    </div>
                    <div class="col-md-2" *ngIf="isTailorMade">
                      <mat-checkbox
                        color="primary"
                        [disabled]="getFittingProcessRole"
                        formControlName="frameAvailable"
                        [tabIndex]="87"
                      >Frame Available
                      </mat-checkbox>
                      <kendo-dropdownlist
                        [data]="shapesList"
                        class="w-100"
                        formControlName="lensShapeId"
                        [textField]="'shapeName'"
                        [valueField]="'shapeId'"
                        [readonly]="getFittingProcessRole"
                        [valuePrimitive]="true"
                        placeholder="Shape"
                        [tabIndex]="88"
                    >
                    (valueChange)="frameAvailableCheck($event)"
                        <ng-template kendoDropDownListItemTemplate  let-dataItem>
                          <img *ngIf="dataItem?.shapeImagePath" [src]="dataItem?.shapeImagePath" width="50" height="40"/> {{dataItem?.shapeName}}
                        </ng-template>
                      </kendo-dropdownlist>

                    </div>
                    <div class="col-md-2 mt-3" *ngIf="isTailorMade">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label [for]="tailorWidth" text="Width"></kendo-label>
                        <kendo-numerictextbox
                          [spinners]="false"
                          #tailorWidth
                          [tabIndex]="89"
                          [step]="1"
                          [min]="48"
                          [max]="80"
                          [format]="'n1'"
                          [readonly]="getFittingProcessRole"
                          class="w-100"
                          formControlName="tailorWidth"
                          [rangeValidation]="false"
                          placeholder="Width"
                          (blur)="
                          validateTailorHeight(
                                  'tailorWidth',
                                  'tailorHeight'
                                )
                              "
                        >
                        </kendo-numerictextbox>
                        <kendo-formerror
                          *ngIf="bothSidesForm.get('tailorWidth').errors?.required"
                          >value is required</kendo-formerror
                        >
                      </kendo-formfield>
                    </div>
                    </div>
                    <div class="col-md-2 mt-3" *ngIf="isTailorMade">
                      <div class="dx-field hightLight">
                        <kendo-formfield>
                          <kendo-label [for]="tailorHeight" text="Height"></kendo-label>
                          <kendo-numerictextbox
                            [spinners]="false"
                            #tailorHeight
                            [step]="1"
                            [min]="48"
                            [max]="80"
                            [format]="'n1'"
                            [tabIndex]="90"
                            [readonly]="getFittingProcessRole"
                            class="w-100"
                            formControlName="tailorHeight"
                            [rangeValidation]="false"
                            placeholder="Height"
                            (blur)="
                            validateTailorHeight(
                                  'tailorWidth',
                                  'tailorHeight'
                                )
                              "
                          >
                          </kendo-numerictextbox>
                          <kendo-formerror *ngIf="bothSidesForm.get('tailorHeight').errors?.required">value is required</kendo-formerror>
                            <kendo-formerror
                              *ngIf="
                                bothSidesForm.get('tailorHeight').errors
                                  ?.inValidHeight
                              "
                              >HEIGHT not allowed greater then
                              WIDTH</kendo-formerror
                            >
                        </kendo-formfield>
                      </div>
                    </div>
                    <ng-container *ngIf="isFitting">
                      <div class="col-md-2">
                        <p class="mb-0 mt-3">
                          <mat-checkbox
                          formControlName="isFrameCase"
                          [disabled]="getFittingProcessRole"
                          color="primary"
                          [tabIndex]="91"
                          ><u>Customer Frame Case</u></mat-checkbox
                        >
                        </p>
                        <p class="mb-0">
                          <mat-checkbox
                          [disabled]="getFittingProcessRole"
                          formControlName="accurateIPD"
                          color="primary"
                          [tabIndex]="92"
                          >Accurate IPD</mat-checkbox
                        >
                        </p>
                        <p class="mb-0">
                          <mat-checkbox
                          [disabled]="getFittingProcessRole"
                          formControlName="isTracing"
                          color="primary"
                          >Verify Tracing </mat-checkbox
                        >
                        </p>
                        
                      </div>
                    </ng-container>
                      <div class="col-md-2">
                        <div
                          class="position-relative mh-150-per d-flex justify-content-center align-items-center"
                        >
                          <mat-form-field class="w-50-per position-absolute top-0">
                            <input
                              type="number"
                              id="up"
                              matInput
                              placeholder="UP"
                              min="-10"
                              max="10"
                              [readonly]="getFittingProcessRole"
                              formControlName="up"
                              [ToFixedDirective]="1"
                              step="0.1"
                              [tabIndex]="93"
                            />
                          </mat-form-field>
                          <dx-tooltip
                            target="#up"
                            [visible]="
                              bothSidesForm.get('up').errors &&
                              bothSidesForm.get('up').touched
                            "
                            [hideOnOutsideClick]="false"
                          >
                            <div
                              *dxTemplate="let data = data; of: 'content'"
                              style="font-size: 14px; color: rgb(217, 83, 79)"
                            >
                              {{
                                bothSidesForm.get("up").errors?.range
                                  ? "UP Min: -10 & Max: 10 allowed"
                                  : ""
                              }}
                              {{
                                bothSidesForm.get("up").errors?.stepError
                                  ? "UP value is not valid"
                                  : ""
                              }}
                            </div>
                          </dx-tooltip>
                          <mat-form-field class="w-50-per position-absolute left-0">
                            <input
                              type="number"
                              matInput
                              placeholder="Temple"
                              id="temple"
                              min="-10"
                              [readonly]="getFittingProcessRole"
                              max="10"
                              formControlName="temple"
                              step="0.1"
                              [ToFixedDirective]="1"
                              [tabIndex]="97"
                            />
                          </mat-form-field>
                          <dx-tooltip
                            target="#temple"
                            [visible]="
                              bothSidesForm.get('temple').errors &&
                              bothSidesForm.get('temple').touched
                            "
                            [hideOnOutsideClick]="false"
                          >
                            <div
                              *dxTemplate="let data = data; of: 'content'"
                              style="font-size: 14px; color: rgb(217, 83, 79)"
                            >
                              {{
                                bothSidesForm.get("temple").errors?.range
                                  ? "Temple Min: -10 & Max: 10 allowed"
                                  : ""
                              }}
                              {{
                                bothSidesForm.get("temple").errors?.stepError
                                  ? "Temple value is not valid"
                                  : ""
                              }}
                            </div>
                          </dx-tooltip>

                          <div
                            style="
                              border: 1px solid #ccc;
                              height: 50px;
                              width: 50px;
                            "
                          ></div>
                          <mat-form-field
                            class="w-50-per position-absolute right-0"
                          >
                            <input
                              type="number"
                              matInput
                              placeholder="Nasal"
                              id="nasel"
                              formControlName="nasel"
                              min="-10"
                              max="10"
                              step="0.1"
                              [readonly]="getFittingProcessRole"
                              [ToFixedDirective]="1"
                              [tabIndex]="98"
                            />
                          </mat-form-field>
                          <dx-tooltip
                            target="#nasel"
                            [visible]="
                              bothSidesForm.get('nasel').errors &&
                              bothSidesForm.get('nasel').touched
                            "
                            [hideOnOutsideClick]="false"
                          >
                            <div
                              *dxTemplate="let data = data; of: 'content'"
                              style="font-size: 14px; color: rgb(217, 83, 79)"
                            >
                              {{
                                bothSidesForm.get("nasel").errors?.range
                                  ? "Nasal Min: -10 & Max: 10 allowed"
                                  : ""
                              }}
                              {{
                                bothSidesForm.get("nasel").errors?.stepError
                                  ? "Nasal value is not valid"
                                  : ""
                              }}
                            </div>
                          </dx-tooltip>
                          <mat-form-field
                            class="w-50-per position-absolute bottom-0"
                          >
                            <input
                              type="number"
                              matInput
                              id="down"
                              [readonly]="getFittingProcessRole"
                              placeholder="Down"
                              formControlName="down"
                              min="-10"
                              max="10"
                              step="0.1"
                              [ToFixedDirective]="1"
                              [tabIndex]="99"
                            />
                          </mat-form-field>
                          <dx-tooltip
                            target="#down"
                            [visible]="
                              bothSidesForm.get('down').errors &&
                              bothSidesForm.get('down').touched
                            "
                            [hideOnOutsideClick]="false"
                          >
                            <div
                              *dxTemplate="let data = data; of: 'content'"
                              style="font-size: 14px; color: rgb(217, 83, 79)"
                            >
                              {{
                                bothSidesForm.get("down").errors?.range
                                  ? "Down Min: -10 & Max: 10 allowed"
                                  : ""
                              }}
                              {{
                                bothSidesForm.get("down").errors?.stepError
                                  ? "Down value is not valid"
                                  : ""
                              }}
                            </div>
                          </dx-tooltip>
                        </div>
                      </div>
                      <div class="col-md-2 text-center">
                        <div class="mt-3">
                          <div>Tracing</div>

                        <div class="d-flex align-items-center upload-btn-wrapper">
                          <div
                            class="logo-upload d-flex align-items-center justify-content-center"
                          >
                            <img
                              class="img-size"
                              src="assets/img/upload_icon.png"
                              alt=""
                              *ngIf="!bothSidesForm.get('tracingImage').value"
                            />
                            <div *ngIf="bothSidesForm.get('tracingImage').value">
                              <i
                                class="fa fa-file-excel-o"
                                aria-hidden="true"
                                *ngIf="
                                  bothSidesForm
                                    .get('tracingImageName')
                                    .value?.includes('pdf')
                                "
                              ></i>
                              <i
                                class="fa fa-file-word-o"
                                aria-hidden="true"
                                *ngIf="
                                  bothSidesForm
                                    .get('tracingImageName')
                                    .value?.includes('docx')
                                "
                              ></i>
                              <i
                                class="fa fa-file-text"
                                aria-hidden="true"
                                *ngIf="
                                  bothSidesForm
                                    .get('tracingImageName')
                                    .value?.includes('txt')
                                "
                              ></i>
                            </div>
                            <input
                              type="file"
                              id="imgInput"
                              [readonly]="getFittingProcessRole"
                              (change)="onFileChange($event)"
                              [tabIndex]="94"
                            />
                            <div
                              class="delete-image"
                              *ngIf="bothSidesForm.get('tracingImage').value"
                              (click)="removeImage()"
                            >
                              <i class="fa fa-times"></i>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="invalidFile">
                          <p style="color: red">Invalid File Format!</p>
                        </div>
                        <div *ngIf="bothSidesForm.get('tracingImage').value">
                          <p>{{ bothSidesForm.get("tracingImageName").value }}</p>
                        </div>
                        </div>
                      </div>
                  </div>
                </div>
            </app-panel>
          </ng-container>
           <!-- <ng-container *ngIf="!isFitting || !isTailorMade">
            <app-panel [backArrow]="false" [footer]="false" #frame>
              <div class="heading">Frame Information</div>
                <div class="body">
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <h2>Add Frame / Tailor Made</h2>
                    </div>
                  </div>
                </div>
              </app-panel>
          </ng-container> -->
            <!--/ FRAME INFORMATION -->
            <div class="mt-3 mb-3"></div>
            <!-- SERVICES -->
            <app-panel [backArrow]="false" [footer]="false">
              <div class="heading">Services</div>
              <div class="body">
                <div class="row">
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="coatInput"
                          text="Coating"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          #coatInput
                          [readonly]="
                            allCoating?.length == 0 || getHcProcessRole
                          "
                          [clearButton]="true"
                          class="w-100"
                          formControlName="coat"
                          [valuePrimitive]="true"
                          [data]="allCoating"
                          [valueField]="'coatingBrandId'"
                          [textField]="'coatingBrandName'"
                          [filterable]="true"
                          [tabIndex]="95"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          [placeholder]="'Coat'"
                          (valueChange)="
                          getRxPrice(
                            selectedItemCatalogObject?.itemCatalogGroupId,
                            bothSidesForm.get('sphRight').value,
                            bothSidesForm.get('cylRight').value,
                            bothSidesForm.get('addfRight').value,
                            'right',
                            selectedItemCatalogObject?.priceGroupMasterId,
                            bothSidesForm.get('diameterRight').value, bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                          );getRxPrice(
                            selectedItemCatalogObject?.itemCatalogGroupId,
                            bothSidesForm.get('sphLeft').value,
                            bothSidesForm.get('cylLeft').value,
                            bothSidesForm.get('addfLeft').value,
                            'left',
                            selectedItemCatalogObject?.priceGroupMasterId,
                            bothSidesForm.get('diameterLeft').value,
                            bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                          );
                            backOnlyActive()
                          "
                          [disabled]="(isApiInProgress$ | async)"
                        >
                        <!-- getCoatingPrice(
                              bothSidesForm.get('coat').value,
                              selectedItemCatalogObject?.brandMasterId,
                              customerId
                            ); -->
                        </kendo-combobox>
                        <kendo-formerror *ngIf="defaultCoatingRoule && bothSidesForm.get('coat').errors?.required">Coating is required</kendo-formerror>
                        <!-- <kendo-formerror *ngIf="coatingPriceRole && bothSidesForm.get('coat').errors?.price">Price is required</kendo-formerror> -->
                      </kendo-formfield>
                      
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="companyBranchId"
                          text="Coating Location"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="false"
                          class="w-100"
                          #companyBranchId
                          formControlName="coatingLocation"
                          [clearButton]="true"
                          [readonly]="getServiceProcessRole"
                          [valuePrimitive]="true"
                          [data]="allCompanyBranches"
                          [valueField]="'companyBranchId'"
                          [textField]="'companyBranchName'"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          [tabIndex]="96"
                          [placeholder]="'Coating Location'"
                        >
                        </kendo-combobox>
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label [for]="coatInput" text="HC"></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          #coatInput
                          [clearButton]="true"
                          [readonly]="getHcProcessRole"
                          class="w-100"
                          formControlName="hc"
                          [valuePrimitive]="true"
                          [data]="allHCoating"
                          [valueField]="'coatingBrandId'"
                          [textField]="'coatingBrandName'"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          [tabIndex]="97"
                          [placeholder]="'HC'"
                          (valueChange)="
                            getHcPrice(
                              bothSidesForm.get('hc').value,
                              selectedItemCatalogObject?.brandMasterId,
                              customerId
                            )
                          "
                           [disabled]="(isApiInProgress$ | async)"
                        >
                        </kendo-combobox>
                        <kendo-formerror *ngIf="hsPriceRole">Price is required</kendo-formerror>
                      </kendo-formfield>
                    </div>
                  </div>
                  <!-- <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="hcLocation"
                          text="HCoating Location"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="true"
                          #hcLocation
                          [readonly]="getServiceProcessRole"
                          class="w-100"
                          formControlName="hcLocation"
                          [valuePrimitive]="true"
                          [data]="allCompanyBranches"
                          [valueField]="'companyBranchId'"
                          [textField]="'companyBranchName'"
                          [filterable]="true"
                          [tabIndex]="98"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          [placeholder]="'HCoating Location'"
                        >
                        </kendo-combobox>
                      </kendo-formfield>
                    </div>
                  </div> -->
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label [for]="mirror" text="Mirror"></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="true"
                          #mirror
                          [readonly]="singleSideRole || getTintMirrorRole || mirrorDisabledRole"
                          class="w-100"
                          formControlName="mirror"
                          [valuePrimitive]="true"
                          [data]="allMirrors"
                          [valueField]="'mirrorId'"
                          [textField]="'mirrorName'"
                          [filterable]="true"
                          [tabIndex]="99"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          [placeholder]="'Mirror'"
                          (valueChange)="
                          getRxPrice(
                            selectedItemCatalogObject?.itemCatalogGroupId,
                            bothSidesForm.get('sphRight').value,
                            bothSidesForm.get('cylRight').value,
                            bothSidesForm.get('addfRight').value,
                            'right',
                            selectedItemCatalogObject?.priceGroupMasterId,
                            bothSidesForm.get('diameterRight').value, bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                          );
                          getRxPrice(
                            selectedItemCatalogObject?.itemCatalogGroupId,
                            bothSidesForm.get('sphLeft').value,
                            bothSidesForm.get('cylLeft').value,
                            bothSidesForm.get('addfLeft').value,
                            'left',
                            selectedItemCatalogObject?.priceGroupMasterId,
                            bothSidesForm.get('diameterLeft').value,
                            bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                          );backOnlyActive();
                            
                          "
                           [disabled]="(isApiInProgress$ | async)"
                        >
                        <!--  getMirrorPrice(
                              bothSidesForm.get('mirror').value,
                              customerId
                            ); -->
                        <!-- tintValidation(bothSidesForm.get('mirror').value) -->
                        </kendo-combobox>
                        <!-- <kendo-formerror *ngIf="mirrorPriceRole">Price is required</kendo-formerror> -->
                      </kendo-formfield>
                    </div>
                  </div>
                  <div
                    class="col-md-2 d-flex align-items-center justify-content-center"
                  >
                    <mat-checkbox
                      formControlName="backOnly"
                      [tabIndex]="100"
                      [disabled]="getServiceProcessRole"
                      [tabIndex] = "106"
                      color="primary"
                      class="mt-3"
                      >Back Only
                    </mat-checkbox>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="tintType"
                          text="{{bothSidesForm.get('tintType').errors?.required ? 'Tint Type *' : 'Tint Type'}}"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="true"
                          #tintType
                          [tabIndex]="101"
                          [readonly]="singleSideRole || getTintMirrorRole"
                          class="w-100"
                          formControlName="tintType"
                          [valuePrimitive]="true"
                          [data]="allTints"
                          [valueField]="'tintId'"
                          [textField]="'tintName'"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          [placeholder]="'Tint Type'"
                          (valueChange)="
                            getTintPrice(
                              bothSidesForm.get('tintType').value,
                              customerId
                            );
                            getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphRight').value,
                                  bothSidesForm.get('cylRight').value,
                                  bothSidesForm.get('addfRight').value,
                                  'right',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterRight').value, bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                );

                            getRxPrice(
                                  selectedItemCatalogObject?.itemCatalogGroupId,
                                  bothSidesForm.get('sphLeft').value,
                                  bothSidesForm.get('cylLeft').value,
                                  bothSidesForm.get('addfLeft').value,
                                  'left',
                                  selectedItemCatalogObject?.priceGroupMasterId,
                                  bothSidesForm.get('diameterLeft').value,
                                  bothSidesForm.get('coat').value, bothSidesForm.get('mirror').value, bothSidesForm.get('tintType').value
                                );
                          "
                           [disabled]="(isApiInProgress$ | async)"
                        >
                        </kendo-combobox>
                        <!-- <kendo-formerror *ngIf="tintPriceRole">Price is required</kendo-formerror> -->
                        <kendo-formerror *ngIf="bothSidesForm.get('tintType').errors?.required">Tint type is required</kendo-formerror>
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="color1"
                          text="{{
                            (!singleSideRole &&
                              selectedTintObject?.tintMasterId == 1) ||
                            selectedTintObject?.tintMasterId == 2 ||
                            selectedTintObject?.tintMasterId == 3
                              ? 'Color 1 *'
                              : 'Color 1'
                          }}"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="true"
                          #color1
                          class="w-100"
                          formControlName="color1"
                          [valuePrimitive]="true"
                          [readonly]="getTintProcessRole || !bothSidesForm.get('tintType').value"
                          [tabIndex]="102"
                          [data]="allColors"
                          [valueField]="'colorId'"
                          [textField]="'colorName'"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          placeholder="{{
                            (!singleSideRole &&
                              selectedTintObject?.tintMasterId == 1) ||
                            selectedTintObject?.tintMasterId == 2 ||
                            selectedTintObject?.tintMasterId == 3
                              ? 'Color 1 *'
                              : 'Color 1'
                          }}"
                        >
                        </kendo-combobox>
                        <kendo-formerror *ngIf="!singleSideRole"
                          >Color is required</kendo-formerror
                        >
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="color2"
                          text="{{
                            !singleSideRole &&
                            selectedTintObject?.tintMasterId == 3
                              ? 'Color 2 *'
                              : 'Color 2'
                          }}"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="false"
                          #color2
                          class="w-100"
                          formControlName="color2"
                          [valuePrimitive]="true"
                          [data]="allColors"
                          [valueField]="'colorId'"
                          [tabIndex]="103"
                          [textField]="'colorName'"
                          [readonly]="getTintProcessRole || !bothSidesForm.get('tintType').value"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          placeholder="{{
                            (!singleSideRole &&
                              selectedTintObject?.tintMasterId == 1) ||
                            selectedTintObject?.tintMasterId == 2 ||
                            selectedTintObject?.tintMasterId == 3
                              ? 'Color 1 *'
                              : 'Color 1'
                          }}"
                        >
                        </kendo-combobox>
                        <kendo-formerror *ngIf="!singleSideRole"
                          >Color is required</kendo-formerror
                        >
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="percentage"
                          text="{{
                            selectedTintObject?.tintMasterId == 4
                              ? 'Percentage'
                              : bothSidesForm.get('tintType').value
                              ? 'Percentage *'
                              : 'Percentage'
                          }}"
                        ></kendo-label>
                        <kendo-numerictextbox
                          [spinners]="false"
                          #percentage
                          [min]="0"
                          [max]="100"
                          [tabIndex]="104"
                          [readonly]="getTintProcessRole || !bothSidesForm.get('tintType').value"
                          [format]="'n0'"
                          class="w-100"
                          formControlName="percentage"
                          [rangeValidation]="false"
                          placeholder="{{
                            selectedTintObject?.tintMasterId == 4
                              ? 'Percentage'
                              : bothSidesForm.get('tintType').value
                              ? 'Percentage *'
                              : 'Percentage'
                          }}"
                        >
                        </kendo-numerictextbox>
                        <kendo-formerror
                          *ngIf="bothSidesForm.get('percentage').errors?.range"
                          >Min: 0 & Max: 100 allowed</kendo-formerror
                        >
                        <kendo-formerror
                          *ngIf="
                            bothSidesForm.get('percentage').errors?.required
                          "
                          >value is required</kendo-formerror
                        >
                      </kendo-formfield>
                    </div>
                  </div>
                  <!-- <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="tintLocation"
                          text="Tint Location"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="false"
                          #tintLocation
                          class="w-100"
                          formControlName="tintLocation"
                          [valuePrimitive]="true"
                          [readonly]="getTintProcessRole"
                          [data]="allCompanyBranches"
                          [valueField]="'companyBranchId'"
                          [tabIndex]="105"
                          [textField]="'companyBranchName'"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          placeholder="Tint Location"
                        >
                        </kendo-combobox>
                      </kendo-formfield>
                    </div>
                  </div> -->
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="otherServices"
                          text="Other Services"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="false"
                          #otherServices
                          class="w-100"
                          formControlName="otherServices"
                          [valuePrimitive]="true"
                          [data]="otherServicesList"
                          [readonly]="getServiceProcessRole"
                          [tabIndex]="106"
                          [valueField]="'otherServiceId'"
                          [textField]="'serviceName'"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          [placeholder]="'Other Services'"
                          (valueChange)="
                            otherServicePrice(
                              bothSidesForm.get('otherServices').value
                            )
                          "
                          [disabled]="(isApiInProgress$ | async)"
                        >
                        </kendo-combobox>
                        <kendo-formerror *ngIf="otherServicePriceRole">Price is required</kendo-formerror>
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label text="Engraviing"></kendo-label>
                        <kendo-textbox
                          [tabIndex]="107"
                          class="w-100"
                          formControlName="nameCode"
                          [readonly]="getServiceProcessRole"
                          placeholder="Engraviing"
                          (blur)="
                            getEngravingPrice(
                              bothSidesForm.get('nameCode').value
                            )
                          "
                          [disabled]="(isApiInProgress$ | async)"
                        >
                        </kendo-textbox>
                        <kendo-formerror *ngIf="engravingPriceRole">Price is required</kendo-formerror>
                      </kendo-formfield>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="dx-field hightLight">
                      <kendo-formfield>
                        <kendo-label
                          [for]="engraveId"
                          text="Logo"
                        ></kendo-label>
                        <kendo-combobox
                          [virtual]="true"
                          [clearButton]="false"
                          #engraveId
                          class="w-100"
                          [tabIndex]="108"
                          formControlName="engraveId"
                          [valuePrimitive]="true"
                          [data]="engravesList"
                          [valueField]="'engraveId'"
                          [textField]="'engraveName'"
                          [readonly]="getServiceProcessRole"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true"
                          [placeholder]="'Logo'"
                          (valueChange)="
                            getSpecialLogoPricing(
                              bothSidesForm.get('engraveId').value
                            )
                          "
                           [disabled]="(isApiInProgress$ | async)"
                        >
                        </kendo-combobox>
                        <kendo-formerror *ngIf="logoPriceRole">Price is required</kendo-formerror>
                      </kendo-formfield>
                    </div>
                  </div>
                  <!-- <div class="col-md-8" *ngIf="bothSidesForm.get('rxPrice').errors?.price">
                    <div class="alert alert-danger">
                        {{bothSidesForm.get('rxPrice').value}}
                    </div>
                  </div> -->
                </div>
              </div>
            </app-panel>
            <!--/ SERVICES -->
            <div class="mt-3 mb-3"></div>

            <!-- CONSULT CALCULATION -->
            <!-- <div class="row">
              <div class="col-md-6">
                <app-panel
                  [backArrow]="false"
                  [footer]="allRequiredErrorShow && bothSidesForm.invalid"
                >
                  <div class="heading">Consult Calculation</div>
                  <div class="body">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="minTHK"
                              text="Min THK"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #minTHK
                              id="minTHK"
                              [format]="'n0'"
                              [tabIndex]="115"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="minTHK"
                              [rangeValidation]="false"
                              placeholder="Min THK"
                            >
                            </kendo-numerictextbox>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="maxTHK"
                              text="Max THK"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #maxTHK
                              id="maxTHK"
                              [format]="'n0'"
                              [tabIndex]="116"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="maxTHK"
                              [rangeValidation]="false"
                              placeholder="Max THK"
                            >
                            </kendo-numerictextbox>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="thkTample"
                              text="THK at Tample"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #thkTample
                              id="thkTample"
                              [format]="'n0'"
                              [tabIndex]="117"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="thkTample"
                              [rangeValidation]="false"
                              placeholder="THK at Tample"
                            >
                            </kendo-numerictextbox>
                          </kendo-formfield>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="dx-field hightLight">
                          <kendo-formfield>
                            <kendo-label
                              [for]="thkNose"
                              text="THK at Tample"
                            ></kendo-label>
                            <kendo-numerictextbox
                              [spinners]="false"
                              #thkNose
                              id="thkNose"
                              [format]="'n0'"
                              [tabIndex]="118"
                              [readonly]="rxProcessRole"
                              class="w-100"
                              formControlName="thkNose"
                              [rangeValidation]="false"
                              placeholder="THK at Nose"
                            >
                            </kendo-numerictextbox>
                          </kendo-formfield>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="footer">
                    <div
                      class="alert alert-danger"
                      role="alert"
                      *ngIf="getFormValidationErrors(bothSidesForm)?.length > 0"
                    >
                      <div><strong>Oops!</strong></div>
                      <div
                        class="e"
                        *ngFor="
                          let error of getFormValidationErrors(bothSidesForm)
                        "
                      >
                        {{ error.error | uppercase }}
                        {{ error?.control | uppercase }}
                      </div>
                    </div>
                    <ng-template
                      [ngIf]="
                        selectedTemplate == 'both' &&
                        bothSidesForm.get('itemCatalogGroupId').value &&
                        atLeastOneServiceRequired?.length == 0
                      "
                    >
                      <div class="row">
                        <div class="col-md-12">
                          <div class="alert alert-danger">
                            Atleast one service is required
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </app-panel>
              </div>
            </div> -->
            <!-- / CONSULT CALCULATION -->

            <div class="row mt-3">
              <div class="col-md-12">
                <button
                  id="refresh"
                  class="btn btn-sm btn-primary mr-3"
                  type="button"
                  (click)="refreshUrl()"
                >
                  Refresh
                </button>
                <button
                  class="btn btn-secondary btn-sm"
                  type="button"
                  appBackButton
                >
                  Cancel
                </button>
                <ng-template [ngIf]="allRequiredErrorShow">
                  <div class="alert alert-danger mt-3" role="alert" *ngIf="getFormValidationErrors(bothSidesForm)?.length > 0">
                    <div><strong>Oops!</strong></div>
                    <div class="e" *ngFor="let error of getFormValidationErrors(bothSidesForm)">{{ error.error | uppercase}} {{error.control | uppercase }}</div>
                  </div>
                </ng-template>
                <div class="clearfix"></div>
                <ng-container *ngIf="isSubmitRole && !(isApiInProgress$ | async) ">
                  <dx-speed-dial-action
                    *ngIf="!loadingIndicator && !(isApiInProgress$ | async)"
                    [tabIndex]="109"
                    icon="add"
                    label="{{ isEdit ? 'Update' : 'Save' }}"
                    [index]="1"
                    (onClick)="savebothSidesForm(bothSidesForm)"
                    [disabled]="loadingIndicator"
                  >
                  </dx-speed-dial-action>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<dx-popup
    class="popup"
    [width]="1000"
    [minHeight]="400"
    [showTitle]="true"
    [showCloseButton]="false"
    title="Combo/ Offers"
    [dragEnabled]="false"
    [hideOnOutsideClick]="false"
    [(visible)]="comboPricePopup"
  >
    <div *dxTemplate="let data of 'content'">
      <dx-scroll-view width="100%" height="100%">
        <dx-data-grid
          id="grid-container"
          #tempGrid
          [dataSource]="comboPriceList"
          [showBorders]="true"
          [hoverStateEnabled]="true"
          [wordWrapEnabled]="true"
          [allowColumnResizing]="true"
          [columnResizingMode]="'widget'"
          (onSelectionChanged)="selectionChangedHandler($event)">
          <dxo-selection
            mode="single"
            showCheckBoxesMode="onClick"
          ></dxo-selection>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
          <dxo-paging [pageSize]="6"></dxo-paging>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <!-- <dxi-column
            dataField="powerRange"
            [width]="200"
            caption="Power Range"
          >
          </dxi-column> -->
          <dxi-column dataField="itemName" caption="Item Name"></dxi-column>
          <dxi-column dataField="coatingName" caption="Coating"> </dxi-column>
          <dxi-column dataField="tintName" caption="Tint"> </dxi-column>
          <dxi-column dataField="mirrorName" caption="Mirror"> </dxi-column>
          <dxi-column dataField="frameName" caption="Frame"> </dxi-column>
          <dxi-column dataField="priceTypeName" caption="Price Type">
          </dxi-column>
          <dxi-column dataField="comboPrice" cssClass="text-center" caption="Price">
          </dxi-column>
        </dx-data-grid>
      </dx-scroll-view>
      <div class="dx-footer">
        <dx-button
        id="button"
        text="Add"
        type="default"
        class="float-right ml-3 mt-3"
        (click)="addToGrid()"
      >
      </dx-button>
        <dx-button
          text="Clear/Close"
          (onClick)="closePopup()"
          class="float-right ml-3 mt-3"
        >
        </dx-button>
      </div> 
    </div>
  </dx-popup>
<swal #saveSwal></swal>
